function getTradeSurvey(zone) {
  let survey = [
    {
      group: 'Personal data',
      link: 'Personal data',
      questions: [
        {
          question: 'Country',
          type: 'select',
          answers: [
            'Afghanistan',
            'Albania',
            'Algeria',
            'American Samoa',
            'Andorra',
            'Angola',
            'Anguilla',
            'Antarctica',
            'Antigua and/or Barbuda',
            'Argentina',
            'Armenia',
            'Aruba',
            'Australia',
            'Austria',
            'Azerbaijan',
            'Bahamas',
            'Bahrain',
            'Bangladesh',
            'Barbados',
            'Belarus',
            'Belgium',
            'Belize',
            'Benin',
            'Bermuda',
            'Bhutan',
            'Bolivia',
            'Bosnia and Herzegovina',
            'Botswana',
            'Bouvet Island',
            'Brazil',
            'British Indian Ocean Territory',
            'Brunei Darussalam',
            'Bulgaria',
            'Burkina Faso',
            'Burundi',
            'Cambodia',
            'Cameroon',
            'Canada',
            'Cape Verde',
            'Cayman Islands',
            'Central African Republic',
            'Chad',
            'Chile',
            'China',
            'Christmas Island',
            'Cocos (Keeling) Islands',
            'Colombia',
            'Comoros',
            'Congo',
            'Cook Islands',
            'Costa Rica',
            'Croatia (Hrvatska)',
            'Cuba',
            'Cyprus',
            'Czech Republic',
            'Denmark',
            'Djibouti',
            'Dominica',
            'Dominican Republic',
            'East Timor',
            'Ecudaor',
            'Egypt',
            'El Salvador',
            'Equatorial Guinea',
            'Eritrea',
            'Estonia',
            'Ethiopia',
            'Falkland Islands (Malvinas)',
            'Faroe Islands',
            'Fiji',
            'Finland',
            'France',
            'France, Metropolitan',
            'French Guiana',
            'French Polynesia',
            'French Southern Territories',
            'Gabon',
            'Gambia',
            'Georgia',
            'Germany',
            'Ghana',
            'Gibraltar',
            'Greece',
            'Greenland',
            'Grenada',
            'Guadeloupe',
            'Guam',
            'Guatemala',
            'Guinea',
            'Guinea-Bissau',
            'Guyana',
            'Haiti',
            'Heard and Mc Donald Islands',
            'Honduras',
            'Hong Kong',
            'Hungary',
            'Iceland',
            'India',
            'Indonesia',
            'Iran (Islamic Republic of)',
            'Iraq',
            'Ireland',
            'Israel',
            'Italy',
            'Ivory Coast',
            'Jamaica',
            'Japan',
            'Jordan',
            'Kazakhstan',
            'Kenya',
            'Kiribati',
            "Korea, Democratic People's Republic of",
            'Korea, Republic of',
            'Kosovo',
            'Kuwait',
            'Kyrgyzstan',
            "Lao People's Democratic Republic",
            'Latvia',
            'Lebanon',
            'Lesotho',
            'Liberia',
            'Libyan Arab Jamahiriya',
            'Liechtenstein',
            'Lithuania',
            'Luxembourg',
            'Macau',
            'Macedonia',
            'Madagascar',
            'Malawi',
            'Malaysia',
            'Maldives',
            'Mali',
            'Malta',
            'Marshall Islands',
            'Martinique',
            'Mauritania',
            'Mauritius',
            'Mayotte',
            'Mexico',
            'Micronesia, Federated States of',
            'Moldova, Republic of',
            'Monaco',
            'Mongolia',
            'Montserrat',
            'Morocco',
            'Mozambique',
            'Myanmar',
            'Namibia',
            'Nauru',
            'Nepal',
            'Netherlands',
            'Netherlands Antilles',
            'New Caledonia',
            'New Zealand',
            'Nicaragua',
            'Niger',
            'Nigeria',
            'Niue',
            'Norfork Island',
            'Northern Mariana Islands',
            'Norway',
            'Oman',
            'Pakistan',
            'Palau',
            'Panama',
            'Papua New Guinea',
            'Paraguay',
            'Peru',
            'Philippines',
            'Pitcairn',
            'Poland',
            'Portugal',
            'Puerto Rico',
            'Qatar',
            'Reunion',
            'Romania',
            'Russian Federation',
            'Rwanda',
            'Saint Kitts and Nevis',
            'Saint Lucia',
            'Saint Vincent and the Grenadines',
            'Samoa',
            'San Marino',
            'Sao Tome and Principe',
            'Saudi Arabia',
            'Senegal',
            'Seychelles',
            'Sierra Leone',
            'Singapore',
            'Slovakia',
            'Slovenia',
            'Solomon Islands',
            'Somalia',
            'South Africa',
            'South Georgia South Sandwich Islands',
            'South Sudan',
            'Spain',
            'Sri Lanka',
            'St. Helena',
            'St. Pierre and Miquelon',
            'Sudan',
            'Suriname',
            'Svalbarn and Jan Mayen Islands',
            'Swaziland',
            'Sweden',
            'Switzerland',
            'Syrian Arab Republic',
            'Taiwan',
            'Tajikistan',
            'Tanzania, United Republic of',
            'Thailand',
            'Togo',
            'Tokelau',
            'Tonga',
            'Trinidad and Tobago',
            'Tunisia',
            'Turkey',
            'Turkmenistan',
            'Turks and Caicos Islands',
            'Tuvalu',
            'Uganda',
            'Ukraine',
            'United Arab Emirates',
            'United Kingdom',
            'United States',
            'United States minor outlying islands',
            'Uruguay',
            'Uzbekistan',
            'Vanuatu',
            'Vatican City State',
            'Venezuela',
            'Vietnam',
            'Virigan Islands (British)',
            'Virgin Islands (U.S.)',
            'Wallis and Futuna Islands',
            'Western Sahara',
            'Yemen',
            'Yugoslavia',
            'Zaire',
            'Zambia',
            'Zimbabwe'
          ]
        },
        {
          question: 'Company name',
          type: 'text'
        },
        {
          question: 'Full name',
          type: 'text'
        },
        {
          question: 'Job Position',
          type: 'text'
        },
        {
          question: 'Email',
          type: 'text'
        },
        {
          question: 'Phone number',
          type: 'text'
        }
      ]
    },
    {
      group: 'Company profiling',
      link: 'Company profiling',
      questions: [
        {
          question: 'Company foundation year',
          type: 'number'
        },
        {
          question: 'Number of employees',
          type: 'number'
        },
        {
          question: 'Type of travel agency',
          type: 'select',
          answers: [
            'Online Travel Agency',
            'Traditional agency',
            'MICE / Business Travel',
            'Tour Operator',
            'Other'
          ]
        },
        {
          question: 'Does your company belong to any travel consortium?',
          type: 'select',
          answers: ['Lista de consortium', 'Other', 'No']
        },
        {
          question:
            'In your opinion, which are your key differential selling points?',
          type: 'multiple',
          order: true,
          maximum: 3,
          answers: [
            'Quality',
            'Variety',
            'Personalization.',
            'Customer Experience',
            'Price',
            'Product',
            'Specialization in the specific destination',
            'Specialization in the specific demand niche',
            'Other'
          ]
        },
        {
          question: 'Which customer segments do you work with?',
          type: 'multiple',
          order: true,
          maximum: 3,
          answers: [
            'High end - Luxury',
            'Sustainable',
            'Adventure',
            'Corporate',
            'Golf',
            'Study / idiomatic',
            'Rural',
            'Ski / Snow',
            'Diving',
            'Nautical',
            'Honeymoon',
            'Other'
          ]
        },
        {
          question: 'Which markets do you work with demand-wise?',
          type: 'multiple',
          answers: [
            'International travel outside Europe',
            'Regional travel within Europe',
            'Domestic travel'
          ]
        },
        {
          question: 'Which services do you offer to your customers?',
          type: 'multiple',
          answers: [
            'Cruise ships',
            'Rent a car',
            'Hotels and accommodation',
            'Packages',
            'Airfare',
            'Transfers',
            'Activities/Excursions',
            'Travel insurance',
            'Events and incentives',
            'Other'
          ]
        },
        {
          question: 'Where do you sell your products?',
          type: 'select',
          answers: [
            'E-commerce',
            'Offline / Live (stores & phone / email)',
            'Both'
          ]
        },
        {
          question:
            'When do you plan and generate travel products for a specific season?',
          type: 'toggle',
          grouped: true,
          numbered: true,
          answers: [
            {
              group: 'Winter',
              answers: [
                '1. January',
                '1. February',
                '1. March',
                '1. April',
                '1. May',
                '1. June',
                '1. July',
                '1. August',
                '1. September',
                '1. October',
                '1. November',
                '1. December'
              ]
            },
            {
              group: 'Summer',
              answers: [
                '2. January',
                '2. February',
                '2. March',
                '2. April',
                '2. May',
                '2. June',
                '2. July',
                '2. August',
                '2. September',
                '2. October',
                '2. November',
                '2. December'
              ]
            },
            {
              group: 'Autumn',
              answers: [
                '3. January',
                '3. February',
                '3. March',
                '3. April',
                '3. May',
                '3. June',
                '3. July',
                '3. August',
                '3. September',
                '3. October',
                '3. November',
                '3. December'
              ]
            },
            {
              group: 'Spring',
              answers: [
                '4. January',
                '4. February',
                '4. March',
                '4. April',
                '4. May',
                '4. June',
                '4. July',
                '4. August',
                '4. September',
                '4. October',
                '4. November',
                '4. December'
              ]
            },
            {
              group: 'I plan and generate products for the whole year',
              answers: [
                '5. January',
                '5. February',
                '5. March',
                '5. April',
                '5. May',
                '5. June',
                '5. July',
                '5. August',
                '5. September',
                '5. October',
                '5. November',
                '5. December'
              ]
            },
            {
              group: "I don't plan for the whole year",
              answers: ["6. I don't plan for the whole year"]
            }
          ]
        },
        {
          question:
            'When do you start selling the generated travel product for a specific season?',
          type: 'toggle',
          grouped: true,
          numbered: true,
          answers: [
            {
              group: 'Winter',
              answers: [
                '1. January',
                '1. February',
                '1. March',
                '1. April',
                '1. May',
                '1. June',
                '1. July',
                '1. August',
                '1. September',
                '1. October',
                '1. November',
                '1. December'
              ]
            },
            {
              group: 'Summer',
              answers: [
                '2. January',
                '2. February',
                '2. March',
                '2. April',
                '2. May',
                '2. June',
                '2. July',
                '2. August',
                '2. September',
                '2. October',
                '2. November',
                '2. December'
              ]
            },
            {
              group: 'Autumn',
              answers: [
                '3. January',
                '3. February',
                '3. March',
                '3. April',
                '3. May',
                '3. June',
                '3. July',
                '3. August',
                '3. September',
                '3. October',
                '3. November',
                '3. December'
              ]
            },
            {
              group: 'Spring',
              answers: [
                '4. January',
                '4. February',
                '4. March',
                '4. April',
                '4. May',
                '4. June',
                '4. July',
                '4. August',
                '4. September',
                '4. October',
                '4. November',
                '4. December'
              ]
            },
            {
              group: 'I plan and generate products for the whole year',
              answers: [
                '5. January',
                '5. February',
                '5. March',
                '5. April',
                '5. May',
                '5. June',
                '5. July',
                '5. August',
                '5. September',
                '5. October',
                '5. November',
                '5. December'
              ]
            },
            {
              group: "I don't sell for the whole year",
              answers: ["6. I don't sell for the whole year"]
            }
          ]
        },
        {
          question:
            'Where do you get the information to create the products from?',
          type: 'multiple',
          answers: [
            'Service provider direct approach',
            'Tour Operators direct approach',
            'Event (Travel fair, workshops, etc)',
            'Booking Engine',
            'GDS',
            'Other'
          ]
        },
        {
          question:
            'Which channels do you use to sell and communicate your products to your customers?',
          type: 'multiple',
          order: true,
          answers: [
            'Your website',
            'Search engines (Google, Bing, etc)',
            'Travel company websites (airline, hotels, etc)',
            'Meta Search Engines (Skyscanner, etc)',
            'Online reviews sites (Tripadvisor, etc)',
            'Newspapers and Supplements',
            'Facebook',
            'Instagram',
            'Youtube',
            'TikTok',
            'Twitter',
            'Twitch',
            'Snapchat',
            'Whatsapp',
            'Online media',
            'Lifestyle and travel print magazines',
            'TV advertising',
            'Travel TV programmes',
            'Official tourism board / office website',
            'Cinema/movies',
            'Online lifestyle and travel magazines',
            'Blogs',
            'Promotional Events',
            'Outdoor advertising',
            'Radio',
            'Stores',
            'Podcasts',
            'Influencers and celebrities',
            'Paper leaflets'
          ]
        },
        {
          question: 'In which ones do you invest (do advertising)?',
          type: 'multiple',
          order: true,
          connected: [1, 12],
          answers: [
            'Your website',
            'Search engines (Google, Bing, etc)',
            'Travel company websites (airline, hotels, etc)',
            'Meta Search Engines (Skyscanner, etc)',
            'Online reviews sites (Tripadvisor, etc)',
            'Newspapers and Supplements',
            'Facebook',
            'Instagram',
            'Youtube',
            'TikTok',
            'Twitter',
            'Twitch',
            'Snapchat',
            'Whatsapp',
            'Online media',
            'Lifestyle and travel print magazines',
            'TV advertising',
            'Travel TV programmes',
            'Official tourism board / office website',
            'Cinema/movies',
            'Online lifestyle and travel magazines',
            'Blogs',
            'Promotional Events',
            'Outdoor advertising',
            'Radio',
            'Stores',
            'Podcasts',
            'Influencers and celebrities',
            'Paper leaflets'
          ]
        },
        {
          question:
            "Tell us about your company's digital presence. Select the ones your company use",
          type: 'text',
          grouped: true,
          answers: [
            {
              group: 'Social media accounts',
              answers: [
                'Facebook. Please leave the url to your account (optional)',
                'Instagram. Please leave the url to your account (optional)',
                'Twitter. Please leave the url to your account (optional)'
              ]
            },
            {
              group: 'Your website',
              answers: [
                'Please leave the url to your website (optional)',
                'Please leave the url to your e-commerce (optional)'
              ]
            }
          ]
        }
      ]
    },
    {
      group: 'Customer profiling',
      link: 'Customer profiling',
      questions: [
        {
          question:
            'What is the age range that predominates within your customers?',
          type: 'multiple',
          order: true,
          maximum: 3,
          answers: [
            '18 - 24 years',
            '25 - 34 years',
            '35 - 44 years',
            '45 - 54 years',
            '55 - 64 years',
            '65 - 74 years',
            '75+ years'
          ]
        },
        {
          question: 'How will your customers travel in the next 12 months?',
          type: 'select',
          grouped: true,
          answers: [
            {
              group: 'International travel outside Europe',
              answers: [
                'More than in the last 12 months',
                'Same than in the last 12 months',
                'Less than in the last 12 months'
              ]
            },
            {
              group: 'Regional travel within Europe',
              answers: [
                'More than in the last 12 months',
                'Same than in the last 12 months',
                'Less than in the last 12 months'
              ]
            },
            {
              group: 'Domestic travel',
              answers: [
                'More than in the last 12 months',
                'Same than in the last 12 months',
                'Less than in the last 12 months'
              ]
            }
          ]
        },
        {
          question:
            'What will your customers spend on travel in the next 12 months?',
          type: 'select',
          grouped: true,
          answers: [
            {
              group: 'International travel outside Europe',
              answers: [
                'More than in the last 12 months',
                'Same than in the last 12 months',
                'Less than in the last 12 months'
              ]
            },
            {
              group: 'Regional travel within Europe',
              answers: [
                'More than in the last 12 months',
                'Same than in the last 12 months',
                'Less than in the last 12 months'
              ]
            },
            {
              group: 'Domestic travel',
              answers: [
                'More than in the last 12 months',
                'Same than in the last 12 months',
                'Less than in the last 12 months'
              ]
            }
          ]
        },
        {
          question: 'How do most of your customers travel?',
          type: 'order',
          answers: [
            'Solo travel',
            'Couple',
            'Family',
            'Friends',
            'Corporate / Business',
            'Group Travel (shared interests: church, competitions, fishing, surf, photography, etc.)',
            'Other'
          ]
        },
        {
          question: 'How do customers purchase products or services from you?',
          type: 'order',
          answers: [
            'Individual products or services',
            'Packages',
            'Combined services'
          ]
        },
        {
          question:
            'On average, how many trips do your customers make per year?',
          type: 'number',
          grouped: true,
          answers: [
            {
              group: 'Amount of trips',
              answers: [
                'International travel outside Europe',
                'Regional travel within Europe',
                'Domestic travel'
              ]
            }
          ]
        },
        {
          question:
            'What is the average trip duration from your customers in days?',
          type: 'number',
          grouped: true,
          answers: [
            {
              group: 'Trip Duration',
              answers: [
                'International travel outside Europe',
                'Regional travel within Europe',
                'Domestic travel'
              ]
            }
          ]
        },
        {
          question: 'Where do your customers usually stay?',
          type: 'multiple',
          order: true,
          maximum: 5,
          answers: [
            'Camping (caravan, autocamper, mobile home, tent)',
            'Glamping (luxury camping)',
            'Boating (house boat, yacht)',
            'Luxury suite/villa',
            'Holiday home (not my own privately owned home)',
            'Private rental (e.g. Airbnb, Homeaway, house swap)',
            'My own private home at the destination',
            'Bed and Breakfast',
            'Budget Hotel/Hostel',
            'Farmhouse',
            'Traditional/ Historic property',
            '3-4* Hotel',
            'Luxury Hotel (5+*)',
            'Boutique Hotel',
            'City hotel',
            'Globally recognised hotel brand (Hilton, Marriott, Sheraton, etc.)',
            'Resort',
            'Cruise',
            'Spa hotel',
            'Contemporary style accommodation/design hotel',
            'Staying with friends or family'
          ]
        },
        {
          question:
            'Which are the top 5 factors your customers consider when travelling to a destination?',
          type: 'multiple',
          order: true,
          maximum: 5,
          answers: [
            'Price level in the country (affordability)',
            'Safety standards/low crime levels',
            'Health and hygiene standards',
            'Pet friendly',
            'Cleanliness',
            'That the destination has few tourists',
            'LGBTQ+-friendly',
            'Accessibility for less mobile',
            'Child friendliness',
            'Easy access to health and medical facilities',
            'Direct flight',
            'Flights from my local airport',
            'Being able to drive to the destination',
            'Environmental concerns and sustainability',
            'Minimizing my carbon footprint',
            'Opportunities for going to theme parks',
            'All inclusive accommodation options',
            'Going to the beach',
            'Shopping',
            'Being active (Sport, adventure)',
            'Wellness/Spa',
            'Nature/outdoor experiences',
            'Cultural experiences (museums, concerts, theaters)',
            'Historical experiences',
            'Big city experiences',
            'Exciting food experience opportunities',
            'Fine dining',
            'Guided/Arranged tours/experiences',
            'Nightlife',
            'Living new experiences',
            'Meeting new people',
            'Gaining a new skill/developing skill, e.g. language, cooking or similar',
            'Interacting with locals',
            'Photography',
            'Availability of VIP exclusive personal services (personal butler/maid/chef/personal shopper)'
          ]
        },
        {
          question:
            'In your opinion, which will be the 3 most demanded destinations this year?',
          type: 'text',
          numbered: true,
          grouped: true,
          answers: [
            {
              group: 'International travel outside Europe',
              answers: [
                '1. Destination A',
                '1. Destination B',
                '1. Destination C'
              ]
            },
            {
              group: 'Regional travel within Europe',
              answers: [
                '2. Destination A',
                '2. Destination B',
                '2. Destination C'
              ]
            },
            {
              group: 'Domestic travel',
              answers: [
                '3. Destination A',
                '3. Destination B',
                '3. Destination C'
              ]
            }
          ]
        },
        {
          question:
            'How important is it for your customers the environment and sustainability?',
          type: 'range',
          minimum: 1,
          maximum: 5
        },
        {
          question:
            'How important is it for your customers to minimize their carbon footprint?',
          type: 'range',
          minimum: 1,
          maximum: 5
        },
        {
          question:
            'What is the level of concern for health and personal security at the destination?',
          type: 'range',
          minimum: 1,
          maximum: 3,
          options: ['High', 'Medium', 'Low'],
          grouped: true,
          numbered: true,
          answers: [
            {
              group: 'Health concerns',
              answers: [
                '1. International travel outside Europe',
                '1. Regional travel within Europe',
                '1. Domestic travel'
              ]
            },
            {
              group: 'Personal security concerns',
              answers: [
                '2. International travel outside Europe',
                '2. Regional travel within Europe',
                '2. Domestic travel'
              ]
            }
          ]
        },
        {
          question:
            'How many months in advance do your customers book your products (in months)?',
          type: 'number',
          grouped: true,
          numbered: true,
          connected: [1, 7],
          answers: [
            {
              group: 'Cruise ships',
              answers: [
                '1. International travel outside Europe',
                '1. Regional travel within Europe',
                '1. Domestic travel'
              ]
            },
            {
              group: 'Rent a car',
              answers: [
                '2. International travel outside Europe',
                '2. Regional travel within Europe',
                '2. Domestic travel'
              ]
            },
            {
              group: 'Hotels and accommodation',
              answers: [
                '3. International travel outside Europe',
                '3. Regional travel within Europe',
                '3. Domestic travel'
              ]
            },
            {
              group: 'Packages',
              answers: [
                '4. International travel outside Europe',
                '4. Regional travel within Europe',
                '4. Domestic travel'
              ]
            },
            {
              group: 'Airfare',
              answers: [
                '5. International travel outside Europe',
                '5. Regional travel within Europe',
                '5. Domestic travel'
              ]
            },
            {
              group: 'Transfers',
              answers: [
                '6. International travel outside Europe',
                '6. Regional travel within Europe',
                '6. Domestic travel'
              ]
            },
            {
              group: 'Activities/Excursions',
              answers: [
                '7. International travel outside Europe',
                '7. Regional travel within Europe',
                '7. Domestic travel'
              ]
            },
            {
              group: 'Travel insurance',
              answers: [
                '8. International travel outside Europe',
                '8. Regional travel within Europe',
                '8. Domestic travel'
              ]
            },
            {
              group: 'Events and incentives',
              answers: [
                '9. International travel outside Europe',
                '9. Regional travel within Europe',
                '9. Domestic travel'
              ]
            },
            {
              group: 'Other',
              answers: [
                '10. International travel outside Europe',
                '10. Regional travel within Europe',
                '10. Domestic travel'
              ]
            }
          ]
        }
      ]
    },
    {
      group: 'Trade Thermometer (Agencies)',
      link: 'Trade Thermometer',
      questions: [
        {
          question:
            'What are your business expectations for the next 12 months?',
          type: 'select',
          answers: ['Better', 'Same', 'Worse']
        }
      ]
    },
    {
      group: 'Relationship between Trade and DMOs',
      link: 'Trade and DMOs',
      description:
        'It is very important to identify collaboration opportunities between the key players in each market. That is why we want to ask you about your relationship with DMOs, particularly regarding co-marketing activities. What is a co-marketing activity?',
      questions: [
        {
          question:
            ' Are you open to design and implement co-marketing activities with DMO’s?',
          type: 'range',
          minimum: 1,
          maximum: 5
        },
        {
          question: 'How important is your company’s relationship with DMO’s?',
          type: 'range',
          minimum: 1,
          maximum: 5
        },
        {
          question: 'How many are you planning in the next 12 months?',
          type: 'number',
          minimum: 1,
          maximum: 12
        },
        {
          question:
            'Which co-marketing activities have you implemented in the past?',
          type: 'multiple',
          answers: [
            'Branded Content',
            'Influencers',
            'Press',
            'Offer development',
            'B2C events',
            'Branded offices',
            'Other',
            'We do not do co-marketing activities'
          ]
        },
        {
          question:
            'What actions can the DMOs make to improve synergies with your agency? A shared promotional initiative that can influence demand for a destination.',
          type: 'range',
          minimum: 1,
          maximum: 5,
          grouped: true,
          answers: [
            {
              group: 'Co-marketing activities',
              answers: [
                'Fam trip',
                'Trainings',
                'Media & content base',
                'Visa & Vaccination Support',
                'Contact with incoming trade',
                'Other'
              ]
            }
          ]
        },
        {
          question:
            'Rate the quality of the training you’ve received regarding the DMOs you work with.',
          type: 'range',
          customLabels: 'trainingQualityLevels',
          minimum: 1,
          maximum: 5
        }
      ]
    }
  ];

  switch (zone) {
    case 'uk':
      survey[0].questions[0]['answers'] = [
        'England',
        'Northern Ireland',
        'Scotland',
        'Wales'
      ];
      break;
    case 'nl':
      survey[0].questions[0]['preSelected'] = 'Netherlands';
      //consortium list (tab 2, question 4) - Replaces "Lista de Consortium" by static list
      delete survey[1].questions[3]['answers'];
      survey[1].questions[3]['answers'] = [
        'Travel Counsellors',
        'The Travel Club',
        'Travel XL',
        'VX',
        'Face2Face Travel',
        'Sunweb Group',
        'TUI',
        'Other',
        'No'
      ];
      break;
    case 'de':
      survey[0].questions[0]['preSelected'] = 'Germany';
      break;
    case 'no':
      survey[0].questions[0]['answers'] = [
        'Denmark',
        'Sweden',
        'Norway',
        'Finland'
      ];
      break;
  }

  return survey;
}

export default function () {
  return {
    trade: getTradeSurvey('en'),
    tradeNL: getTradeSurvey('nl'),
    tradeDE: getTradeSurvey('de'),
    tradeUK: getTradeSurvey('uk'),
    tradeNO: getTradeSurvey('no'),
    tradeFrench: [
      {
        group: 'Données personnelles',
        link: 'Données personnelles',
        questions: [
          {
            question: 'Pays',
            type: 'select',
            preSelected: 'France',
            answers: [
              'Afghanistan',
              'Albania',
              'Algeria',
              'American Samoa',
              'Andorra',
              'Angola',
              'Anguilla',
              'Antarctica',
              'Antigua and/or Barbuda',
              'Argentina',
              'Armenia',
              'Aruba',
              'Australia',
              'Austria',
              'Azerbaijan',
              'Bahamas',
              'Bahrain',
              'Bangladesh',
              'Barbados',
              'Belarus',
              'Belgium',
              'Belize',
              'Benin',
              'Bermuda',
              'Bhutan',
              'Bolivia',
              'Bosnia and Herzegovina',
              'Botswana',
              'Bouvet Island',
              'Brazil',
              'British Indian Ocean Territory',
              'Brunei Darussalam',
              'Bulgaria',
              'Burkina Faso',
              'Burundi',
              'Cambodia',
              'Cameroon',
              'Canada',
              'Cape Verde',
              'Cayman Islands',
              'Central African Republic',
              'Chad',
              'Chile',
              'China',
              'Christmas Island',
              'Cocos (Keeling) Islands',
              'Colombia',
              'Comoros',
              'Congo',
              'Cook Islands',
              'Costa Rica',
              'Croatia (Hrvatska)',
              'Cuba',
              'Cyprus',
              'Czech Republic',
              'Denmark',
              'Djibouti',
              'Dominica',
              'Dominican Republic',
              'East Timor',
              'Ecudaor',
              'Egypt',
              'El Salvador',
              'Equatorial Guinea',
              'Eritrea',
              'Estonia',
              'Ethiopia',
              'Falkland Islands (Malvinas)',
              'Faroe Islands',
              'Fiji',
              'Finland',
              'France',
              'France, Metropolitan',
              'French Guiana',
              'French Polynesia',
              'French Southern Territories',
              'Gabon',
              'Gambia',
              'Georgia',
              'Germany',
              'Ghana',
              'Gibraltar',
              'Greece',
              'Greenland',
              'Grenada',
              'Guadeloupe',
              'Guam',
              'Guatemala',
              'Guinea',
              'Guinea-Bissau',
              'Guyana',
              'Haiti',
              'Heard and Mc Donald Islands',
              'Honduras',
              'Hong Kong',
              'Hungary',
              'Iceland',
              'India',
              'Indonesia',
              'Iran (Islamic Republic of)',
              'Iraq',
              'Ireland',
              'Israel',
              'Italy',
              'Ivory Coast',
              'Jamaica',
              'Japan',
              'Jordan',
              'Kazakhstan',
              'Kenya',
              'Kiribati',
              "Korea, Democratic People's Republic of",
              'Korea, Republic of',
              'Kosovo',
              'Kuwait',
              'Kyrgyzstan',
              "Lao People's Democratic Republic",
              'Latvia',
              'Lebanon',
              'Lesotho',
              'Liberia',
              'Libyan Arab Jamahiriya',
              'Liechtenstein',
              'Lithuania',
              'Luxembourg',
              'Macau',
              'Macedonia',
              'Madagascar',
              'Malawi',
              'Malaysia',
              'Maldives',
              'Mali',
              'Malta',
              'Marshall Islands',
              'Martinique',
              'Mauritania',
              'Mauritius',
              'Mayotte',
              'Mexico',
              'Micronesia, Federated States of',
              'Moldova, Republic of',
              'Monaco',
              'Mongolia',
              'Montserrat',
              'Morocco',
              'Mozambique',
              'Myanmar',
              'Namibia',
              'Nauru',
              'Nepal',
              'Netherlands',
              'Netherlands Antilles',
              'New Caledonia',
              'New Zealand',
              'Nicaragua',
              'Niger',
              'Nigeria',
              'Niue',
              'Norfork Island',
              'Northern Mariana Islands',
              'Norway',
              'Oman',
              'Pakistan',
              'Palau',
              'Panama',
              'Papua New Guinea',
              'Paraguay',
              'Peru',
              'Philippines',
              'Pitcairn',
              'Poland',
              'Portugal',
              'Puerto Rico',
              'Qatar',
              'Reunion',
              'Romania',
              'Russian Federation',
              'Rwanda',
              'Saint Kitts and Nevis',
              'Saint Lucia',
              'Saint Vincent and the Grenadines',
              'Samoa',
              'San Marino',
              'Sao Tome and Principe',
              'Saudi Arabia',
              'Senegal',
              'Seychelles',
              'Sierra Leone',
              'Singapore',
              'Slovakia',
              'Slovenia',
              'Solomon Islands',
              'Somalia',
              'South Africa',
              'South Georgia South Sandwich Islands',
              'South Sudan',
              'Spain',
              'Sri Lanka',
              'St. Helena',
              'St. Pierre and Miquelon',
              'Sudan',
              'Suriname',
              'Svalbarn and Jan Mayen Islands',
              'Swaziland',
              'Sweden',
              'Switzerland',
              'Syrian Arab Republic',
              'Taiwan',
              'Tajikistan',
              'Tanzania, United Republic of',
              'Thailand',
              'Togo',
              'Tokelau',
              'Tonga',
              'Trinidad and Tobago',
              'Tunisia',
              'Turkey',
              'Turkmenistan',
              'Turks and Caicos Islands',
              'Tuvalu',
              'Uganda',
              'Ukraine',
              'United Arab Emirates',
              'United Kingdom',
              'United States',
              'United States minor outlying islands',
              'Uruguay',
              'Uzbekistan',
              'Vanuatu',
              'Vatican City State',
              'Venezuela',
              'Vietnam',
              'Virigan Islands (British)',
              'Virgin Islands (U.S.)',
              'Wallis and Futuna Islands',
              'Western Sahara',
              'Yemen',
              'Yugoslavia',
              'Zaire',
              'Zambia',
              'Zimbabwe'
            ]
          },
          {
            question: 'Nom de l’entreprise',
            type: 'text'
          },
          {
            question: 'Nom et prénom',
            type: 'text'
          },
          {
            question: 'Intitulé de poste',
            type: 'text'
          },
          {
            question: 'Email',
            type: 'text'
          },
          {
            question: 'Numéro de téléphone',
            type: 'text'
          }
        ]
      },
      {
        group: 'Profil de l’entreprise',
        link: 'Profil de l’entreprise',
        questions: [
          {
            question: 'Année de création de l’entreprise',
            type: 'number'
          },
          {
            question: 'Nombre d’employés',
            type: 'number'
          },
          {
            question: 'Type d’agence',
            type: 'select',
            answers: [
              'Agence de voyages en ligne',
              'Agence de voyages traditionnelle',
              'Agence MICE/ Voyage d’affaires',
              'Tour-opérateur',
              'Autre'
            ]
          },
          {
            question:
              'Votre entreprise fait-elle partie d’un réseau d’agences de voyage (consortium) ?',
            type: 'select',
            answers: [
              'Tourcom',
              'Selectour',
              'Havas Voyages',
              'Manor',
              'Cediv',
              'Leclerc Voyages',
              'TUI France',
              'Carrefour Voyages',
              'Auchan Voyages',
              'Autre',
              'Non'
            ]
          },
          {
            question:
              'À votre avis, quels sont les principaux arguments de vente différenciants de votre entreprise ?',
            type: 'multiple',
            order: true,
            maximum: 3,
            answers: [
              'Qualité',
              'Variété',
              'Personnalisation',
              'Expérience client',
              'Prix',
              'Produit',
              'Spécialiste d’une destination',
              'Spécialiste d’un produit de niche',
              'Autre'
            ]
          },
          {
            question: 'Quel est votre segment de clientèle ?',
            type: 'multiple',
            order: true,
            maximum: 3,
            answers: [
              'Haut de gamme – Luxe',
              'Tourisme responsable',
              'Aventure',
              'Affaires',
              'Golf',
              'Études / stages linguistiques',
              'Rural',
              'Ski / Neige',
              'Plongée',
              'Nautique',
              'Voyages de noces',
              'Autre'
            ]
          },
          {
            question:
              'Au niveau de la demande, sur quels marchés travaillez-vous ? ',
            type: 'multiple',
            answers: [
              'Voyages internationaux hors Europe',
              'Voyages régionaux en Europe',
              'Voyages domestiques'
            ]
          },
          {
            question: 'Quels services offrez-vous à vos clients ?',
            type: 'multiple',
            answers: [
              'Croisières',
              'Location de voitures',
              'Hôtels et hébergement',
              'Packages (voyages à forfait)',
              'Billets d’avion',
              'Transferts',
              'Activités et excursions',
              'Assurance voyage',
              'Événements et incentives',
              'Autre'
            ]
          },
          {
            question: 'Où vendez-vous vos produits ?',
            type: 'select',
            answers: [
              'E-commerce (site de vente en ligne)',
              'En personne / En direct (en agence, au téléphone, par email)',
              'Les deux'
            ]
          },
          {
            question:
              'A quelle période concevez-vous vos voyages selon une saison spécifique ?',
            type: 'toggle',
            grouped: true,
            numbered: true,
            answers: [
              {
                group: 'Hiver',
                answers: [
                  '1. Janvier',
                  '1. Février',
                  '1. Mars',
                  '1. Avril',
                  '1. Mai',
                  '1. Juin',
                  '1. Juillet',
                  '1. Août',
                  '1. Septembre',
                  '1. Octobre',
                  '1. Novembre',
                  '1. Décembre'
                ]
              },
              {
                group: 'Été',
                answers: [
                  '2. Janvier',
                  '2. Février',
                  '2. Mars',
                  '2. Avril',
                  '2. Mai',
                  '2. Juin',
                  '2. Juillet',
                  '2. Août',
                  '2. Septembre',
                  '2. Octobre',
                  '2. Novembre',
                  '2. Décembre'
                ]
              },
              {
                group: 'Printemps',
                answers: [
                  '3. Janvier',
                  '3. Février',
                  '3. Mars',
                  '3. Avril',
                  '3. Mai',
                  '3. Juin',
                  '3. Juillet',
                  '3. Août',
                  '3. Septembre',
                  '3. Octobre',
                  '3. Novembre',
                  '3. Décembre'
                ]
              },
              {
                group: 'Automne',
                answers: [
                  '4. Janvier',
                  '4. Février',
                  '4. Mars',
                  '4. Avril',
                  '4. Mai',
                  '4. Juin',
                  '4. Juillet',
                  '4. Août',
                  '4. Septembre',
                  '4. Octobre',
                  '4. Novembre',
                  '4. Décembre'
                ]
              },
              {
                group: "Je planifie pour l'année entière",
                answers: [
                  '5. Janvier',
                  '5. Février',
                  '5. Mars',
                  '5. Avril',
                  '5. Mai',
                  '5. Juin',
                  '5. Juillet',
                  '5. Août',
                  '5. Septembre',
                  '5. Octobre',
                  '5. Novembre',
                  '5. Décembre'
                ]
              },
              {
                group: "Je ne planifie pas pour l'année entière",
                answers: ["6. Je ne planifie pas pour l'année entière"]
              }
            ]
          },
          {
            question:
              'A quelle période commencez-vous la vente de voyage selon une saison spécifique ? ',
            type: 'toggle',
            grouped: true,
            numbered: true,
            answers: [
              {
                group: 'Hiver',
                answers: [
                  '1. Janvier',
                  '1. Février',
                  '1. Mars',
                  '1. Avril',
                  '1. Mai',
                  '1. Juin',
                  '1. Juillet',
                  '1. Août',
                  '1. Septembre',
                  '1. Octobre',
                  '1. Novembre',
                  '1. Décembre'
                ]
              },
              {
                group: 'Été',
                answers: [
                  '2. Janvier',
                  '2. Février',
                  '2. Mars',
                  '2. Avril',
                  '2. Mai',
                  '2. Juin',
                  '2. Juillet',
                  '2. Août',
                  '2. Septembre',
                  '2. Octobre',
                  '2. Novembre',
                  '2. Décembre'
                ]
              },
              {
                group: 'Printemps',
                answers: [
                  '3. Janvier',
                  '3. Février',
                  '3. Mars',
                  '3. Avril',
                  '3. Mai',
                  '3. Juin',
                  '3. Juillet',
                  '3. Août',
                  '3. Septembre',
                  '3. Octobre',
                  '3. Novembre',
                  '3. Décembre'
                ]
              },
              {
                group: 'Automne',
                answers: [
                  '4. Janvier',
                  '4. Février',
                  '4. Mars',
                  '4. Avril',
                  '4. Mai',
                  '4. Juin',
                  '4. Juillet',
                  '4. Août',
                  '4. Septembre',
                  '4. Octobre',
                  '4. Novembre',
                  '4. Décembre'
                ]
              },
              {
                group: "Je vends pour l'année entière",
                answers: [
                  '5. Janvier',
                  '5. Février',
                  '5. Mars',
                  '5. Avril',
                  '5. Mai',
                  '5. Juin',
                  '5. Juillet',
                  '5. Août',
                  '5. Septembre',
                  '5. Octobre',
                  '5. Novembre',
                  '5. Décembre'
                ]
              },
              {
                group: "Je ne vends pas pendant l'année entière",
                answers: ["6. Je ne vends pas pendant l'année entière"]
              }
            ]
          },
          {
            question:
              'Où cherchez-vous les informations pour créer vos produits ?',
            type: 'multiple',
            answers: [
              'Approche directe du prestataire de service',
              'Approche directe des voyagistes',
              'Événements (salons du tourisme, workshops etc.)',
              'Moteur de réservation',
              'GDS',
              'Autre'
            ]
          },
          {
            question:
              'Quels canaux utilisez-vous pour vendre et communiquer vos produits auprès de vos clients ?',
            type: 'multiple',
            order: true,
            answers: [
              'Votre site internet',
              'Moteurs de recherche (Google, Bing..)',
              'Sites web des compagnies de voyage (compagnies aériennes, hôtels, etc.)',
              'Site internet d’un comparateur (Skyscanner etc.)',
              "Sites d'avis en ligne (Tripadvisor, etc.)",
              'Journaux et suppléments (presse écrite et/ou en ligne)',
              'Facebook',
              'Instagram',
              'Youtube',
              'TikTok',
              'Twitter',
              'Twitch',
              'Snapchat',
              'Whatsapp',
              'Médias en ligne',
              "Magazines papier sur l'art de vivre et les voyages",
              'Publicité télévisée',
              'Programmes télévisés sur les voyages',
              'Offices du tourisme /Site internet d’offices du tourisme',
              'Cinéma/films',
              "Magazines en ligne sur l'art de vivre et les voyages",
              'Blogs',
              'Événements promotionnels',
              'Publicité extérieure / affiche publicitaire ',
              'Radio',
              'Agences physiques',
              'Podcasts',
              'Influenceurs et célébrités',
              'Brochures papier'
            ]
          },
          {
            question:
              'Dans lesquels investissez-vous (en termes de publicité) ?',
            type: 'multiple',
            order: true,
            connected: [1, 12],
            answers: [
              'Votre site internet',
              'Moteurs de recherche (Google, Bing..)',
              'Sites web des compagnies de voyage (compagnies aériennes, hôtels, etc.)',
              'Site internet d’un comparateur (Skyscanner etc.)',
              "Sites d'avis en ligne (Tripadvisor, etc.)",
              'Journaux et suppléments (presse écrite et/ou en ligne)',
              'Facebook',
              'Instagram',
              'Youtube',
              'TikTok',
              'Twitter',
              'Twitch',
              'Snapchat',
              'Whatsapp',
              'Médias en ligne',
              "Magazines papier sur l'art de vivre et les voyages",
              'Publicité télévisée',
              'Programmes télévisés sur les voyages',
              'Offices du tourisme /Site internet d’offices du tourisme',
              'Cinéma/films',
              "Magazines en ligne sur l'art de vivre et les voyages",
              'Blogs',
              'Événements promotionnels',
              'Publicité extérieure / affiche publicitaire ',
              'Radio',
              'Agences physiques',
              'Podcasts',
              'Influenceurs et célébrités',
              'Brochures papier'
            ]
          },
          {
            question:
              'Sur quels canaux digitaux votre entreprise est-elle présente ? Veuillez sélectionner ceux utilisés par votre entreprise',
            type: 'text',
            grouped: true,
            answers: [
              {
                group: 'Réseaux sociaux',
                answers: [
                  'Facebook.URL du compte de l’entreprise (optionnel)',
                  'Instagram. URL du compte de l’entreprise (optionnel)',
                  'Twitter. URL du compte de l’entreprise (optionnel)'
                ]
              },
              {
                group: 'Votre site internet',
                answers: [
                  'URL de votre site internet (optionnel)',
                  'URL de votre site de e-commerce (optionnel)'
                ]
              }
            ]
          }
        ]
      },
      {
        group: 'Profil des clients',
        link: 'Profil des clients',
        questions: [
          {
            question:
              'Quelle est la tranche d’âge prédominante de vos clients? 3 choix et tri par Ordre d’importance',
            type: 'multiple',
            order: true,
            maximum: 3,
            answers: [
              '18 - 24 ans',
              '25 - 34 ans',
              '35 - 44 ans',
              '45 - 54 ans',
              '55 - 64 ans',
              '65 - 74 ans',
              '+75 ans'
            ]
          },
          {
            question:
              'Comment pensez-vous que vos clients voyageront au cours des 12 prochains mois? (En termes de fréquence)',
            type: 'select',
            grouped: true,
            answers: [
              {
                group: 'Voyages internationaux hors Europe',
                answers: [
                  'Plus élevé que dans les 12 derniers mois',
                  'Le même que dans les 12 derniers mois',
                  'Moins élevé que dans les 12 derniers mois'
                ]
              },
              {
                group: 'Voyages régionaux en Europe',
                answers: [
                  'Plus élevé que dans les 12 derniers mois',
                  'Le même que dans les 12 derniers mois',
                  'Moins élevé que dans les 12 derniers mois'
                ]
              },
              {
                group: 'Voyages domestiques',
                answers: [
                  'Plus élevé que dans les 12 derniers mois',
                  'Le même que dans les 12 derniers mois',
                  'Moins élevé que dans les 12 derniers mois'
                ]
              }
            ]
          },
          {
            question:
              'Comment pensez-vous que le budget voyage de vos clients va évoluer dans les 12 prochains mois ?',
            type: 'select',
            grouped: true,
            answers: [
              {
                group: 'Voyages internationaux hors Europe',
                answers: [
                  'Plus élevé que dans les 12 derniers mois',
                  'Le même que dans les 12 derniers mois',
                  'Moins élevé que dans les 12 derniers mois'
                ]
              },
              {
                group: 'Voyages régionaux en Europe',
                answers: [
                  'Plus élevé que dans les 12 derniers mois',
                  'Le même que dans les 12 derniers mois',
                  'Moins élevé que dans les 12 derniers mois'
                ]
              },
              {
                group: 'Voyages domestiques',
                answers: [
                  'Plus élevé que dans les 12 derniers mois',
                  'Le même que dans les 12 derniers mois',
                  'Moins élevé que dans les 12 derniers mois'
                ]
              }
            ]
          },
          {
            question: 'Comment voyagent vos clients ?',
            type: 'order',
            answers: [
              'Voyage en solo',
              'En couple',
              'En famille',
              'Avec des amis',
              'Voyage d’affaires',
              'En groupe (mêmes intérêts : voyages religieux, compétitions, pêche, surf, photographie etc.)',
              'Autre'
            ]
          },
          {
            question:
              'Quel types de produits et services vos clients réservent-ils ?',
            type: 'order',
            answers: [
              'Prestations ou services individuels',
              'Voyages à forfait',
              'Services combinés'
            ]
          },
          {
            question:
              'En moyenne, combien de voyages vos clients effectuent-ils par an ?',
            type: 'number',
            grouped: true,
            answers: [
              {
                group: 'Voyages',
                answers: [
                  'Voyages internationaux hors Europe',
                  'Voyages régionaux en Europe',
                  'Voyages domestiques'
                ]
              }
            ]
          },
          {
            question:
              'Quelle est la durée moyenne de séjours de vos clients (en nombre de jours) ?',
            type: 'number',
            grouped: true,
            answers: [
              {
                group: 'Durée moyenne',
                answers: [
                  'Voyages internationaux hors Europe',
                  'Voyages régionaux en Europe',
                  'Voyages domestiques'
                ]
              }
            ]
          },
          {
            question:
              'Quels sont les types d’hébergement privilégiés par vos clients ?',
            type: 'multiple',
            order: true,
            maximum: 5,
            answers: [
              'Camping (caravane, camping car, mobil-home, tente)',
              'Glamping (camping de luxe)',
              'Bateau (péniche, yacht)',
              'Suite/villa de luxe',
              'Maison de vacances (pas votre propre maison privée)',
              'Location privée (par exemple Airbnb, Homeaway, échange de maison)',
              'Ma résidence secondaire à destination',
              'Bed&Breakfast',
              'Hôtel/auberge économique',
              'Ferme',
              'Propriété traditionnelle/ historique',
              'Hôtel 3-4*',
              'Hôtel de luxe (5+*)',
              'Boutique hôtel',
              'Hôtel urbain',
              "Chaîne d'hôtels mondialement reconnue (Hilton, Marriott, Sheraton, etc.)",
              'Resorts / clubs de vacance',
              'Croisière',
              'Hôtel spa',
              'Hébergement de style contemporain/ hôtel design',
              'Séjourner chez des amis ou de la famille'
            ]
          },
          {
            question:
              'Quels sont les 5 principaux critères de choix d’une destination pour vos clients ?',
            type: 'multiple',
            order: true,
            maximum: 5,
            answers: [
              'Niveau des prix dans le pays (abordable)',
              'Sécurité/taux de criminalité faible',
              "Normes de santé et d'hygiène",
              'Accueil des animaux domestiques',
              'Propreté',
              'Le fait que la destination accueille peu de touristes',
              'LGBTQ+',
              'Accessibilité aux personnes à mobilité réduite',
              'Destination adaptée aux enfants',
              'Accès facile aux soins et aux structures médicales ',
              'Vol direct',
              'Vols au départ de mon aéroport local',
              'Possibilité de se rendre en voiture dans cette destination',
              'Exigences environnementales et développement durable',
              'Minimiser mon empreinte carbone',
              'Possibilité de visiter des parcs à thème',
              "Options d'hébergement tout compris",
              'Aller à la plage',
              'Faire du shopping',
              'Être actif (sport, aventure)',
              'Bien-être/Spa',
              'Nature/activités de plein air',
              'Expériences culturelles (musées, concerts, théâtres)',
              'Expériences historiques',
              'Expériences dans les grandes villes',
              'Expériences culinaires exclusives',
              'Dîner gastronomique',
              'Visites guidées/expériences organisées',
              'Vie nocturne',
              'Vivre de nouvelles expériences',
              'Rencontrer de nouvelles personnes',
              'Acquérir une nouvelle compétence/développer une compétence, par exemple une langue, la cuisine ou autre.',
              'Interagir avec la population locale',
              'Photographie',
              "Disponibilité de services personnels exclusifs VIP (maître d'hôtel, femme de chambre, chef cuisinier, personal shopper)"
            ]
          },
          {
            question:
              'Quelles seront, à votre avis, les 3 destinations les plus demandées cette année ?',
            type: 'text',
            numbered: true,
            grouped: true,
            answers: [
              {
                group: 'Voyages internationaux hors Europe',
                answers: [
                  '1. Destination A',
                  '1. Destination B',
                  '1. Destination C'
                ]
              },
              {
                group: 'Voyages régionaux en Europe',
                answers: [
                  '2. Destination A',
                  '2. Destination B',
                  '2. Destination C'
                ]
              },
              {
                group: 'Voyages domestiques',
                answers: [
                  '3. Destination A',
                  '3. Destination B',
                  '3. Destination C'
                ]
              }
            ]
          },
          {
            question:
              'Quelle importance vos clients accordent-ils au respect de l’environnement et au tourisme durable ?',
            type: 'range',
            minimum: 1,
            maximum: 5
          },
          {
            question:
              'Quelle importance vos clients accordent-ils à la réduction de leur empreinte carbone ?',
            type: 'range',
            minimum: 1,
            maximum: 5
          },
          {
            question:
              'Quelle importance vos clients accordent-ils à la santé et la sécurité à destination ?',
            type: 'range',
            minimum: 1,
            maximum: 3,
            options: ['Haute', 'Moyenne', 'Faible'],
            grouped: true,
            numbered: true,
            answers: [
              {
                group: 'Santé',
                answers: [
                  '1. Voyages internationaux hors Europe',
                  '1. Voyages régionaux en Europe',
                  '1. Voyages domestiques'
                ]
              },
              {
                group: 'Sécurité',
                answers: [
                  '2. Voyages internationaux hors Europe',
                  '2. Voyages régionaux en Europe',
                  '2. Voyages domestiques'
                ]
              }
            ]
          },
          {
            question:
              'Combien de temps en avance vos clients réservent-ils leurs produits en moyenne (en semaines) ?',
            type: 'number',
            grouped: true,
            numbered: true,
            connected: [1, 7],
            answers: [
              {
                group: 'Croisières',
                answers: [
                  '1. Voyages internationaux hors Europe',
                  '1. Voyages régionaux en Europe',
                  '1. Voyages domestiques'
                ]
              },
              {
                group: 'Location de voitures',
                answers: [
                  '2. Voyages internationaux hors Europe',
                  '2. Voyages régionaux en Europe',
                  '2. Voyages domestiques'
                ]
              },
              {
                group: 'Hôtels et hébergement',
                answers: [
                  '3. Voyages internationaux hors Europe',
                  '3. Voyages régionaux en Europe',
                  '3. Voyages domestiques'
                ]
              },
              {
                group: 'Voyages à forfait',
                answers: [
                  '4. Voyages internationaux hors Europe',
                  '4. Voyages régionaux en Europe',
                  '4. Voyages domestiques'
                ]
              },
              {
                group: 'Billets d’avion',
                answers: [
                  '5. Voyages internationaux hors Europe',
                  '5. Voyages régionaux en Europe',
                  '5. Voyages domestiques'
                ]
              },
              {
                group: 'Transferts',
                answers: [
                  '6. Voyages internationaux hors Europe',
                  '6. Voyages régionaux en Europe',
                  '6. Voyages domestiques'
                ]
              },
              {
                group: 'Activités et excursions',
                answers: [
                  '7. Voyages internationaux hors Europe',
                  '7. Voyages régionaux en Europe',
                  '7. Voyages domestiques'
                ]
              },
              {
                group: 'Assurance voyage',
                answers: [
                  '8. Voyages internationaux hors Europe',
                  '8. Voyages régionaux en Europe',
                  '8. Voyages domestiques'
                ]
              },
              {
                group: 'Événements et incentives',
                answers: [
                  '9. Voyages internationaux hors Europe',
                  '9. Voyages régionaux en Europe',
                  '9. Voyages domestiques'
                ]
              },
              {
                group: 'Autre',
                answers: [
                  '10. Voyages internationaux hors Europe',
                  '10. Voyages régionaux en Europe',
                  '10. Voyages domestiques'
                ]
              }
            ]
          }
        ]
      },
      {
        group: 'Thermomètre Trade (Agences)',
        link: 'Thermomètre Trade',
        questions: [
          {
            question:
              'Quelles sont vos prévisions pour les 12 prochains mois, en termes de business ?',
            type: 'select',
            answers: ['Meilleure', 'Similaire', 'Pire']
          }
        ]
      },
      {
        group:
          'Relation entre les agences et les DMO (organismes de promotion de destination)',
        link: 'Agences et les DMO',
        description:
          'Il est très important d’identifier les opportunités de collaboration entre les acteurs clés de chaque marché. C’est pourquoi, nous souhaitons vous interroger sur vos relations avec les organismes de promotion de destinations (DMO), particulièrement concernant les campagnes marketing conjointes. Qu’est-ce qu’une campagne marketing conjointe ?',
        questions: [
          {
            question:
              'Êtes-vous favorable à la création et la mise en place de campagne marketing conjointe avec des destinations touristiques ?',
            type: 'range',
            minimum: 1,
            maximum: 5
          },
          {
            question:
              "Quelle est l'importance des relations de votre entreprise avec les destinations touristiques ?",
            type: 'range',
            minimum: 1,
            maximum: 5
          },
          {
            question:
              'Combien de campagnes marketing conjointes avez-vous mis en place ces 12 derniers mois ?',
            type: 'number',
            minimum: 1,
            maximum: 12
          },
          {
            question:
              'Quel type de campagne marketing conjointe avez-vous mis en place par le passé ?',
            type: 'multiple',
            answers: [
              'Contenu sponsorisé',
              'Influenceurs',
              'Presse',
              'Développement d’offre',
              'Événement B2C',
              'Affichages en agence',
              'Autre',
              'Nous ne nous engageons pas dans des activités de marketing conjointe'
            ]
          },
          {
            question:
              'Quelles actions les organismes de promotion de destinations (DMO) pourraient-elles mettre en place pour améliorer les synergies avec votre agence ? Une initiative promotionnelle partagée qui peut influencer la demande vers une destination.',
            type: 'range',
            minimum: 1,
            maximum: 5,
            grouped: true,
            answers: [
              {
                group: 'Actions de promotion',
                answers: [
                  'Eductour',
                  'Formations',
                  'Contenus media et Supports de communication',
                  'Appui technique sur les questions liées au visa et à la vaccination',
                  'Mise en relation avec des réceptifs',
                  'Autre'
                ]
              }
            ]
          },
          {
            question:
              'Évaluez la qualité de la formation que vous avez reçue concernant les DMO avec lesquels vous travaillez.',
            type: 'range',
            customLabels: 'trainingQualityLevels',
            minimum: 1,
            maximum: 5
          }
        ]
      }
    ],
    tradeSpanish: [
      {
        group: 'Datos personales',
        link: 'Datos personales',
        questions: [
          {
            question: 'País',
            type: 'select',
            preSelected: 'España',
            answers: [
              'Afghanistan',
              'Albania',
              'Algeria',
              'American Samoa',
              'Andorra',
              'Angola',
              'Anguilla',
              'Antarctica',
              'Antigua and/or Barbuda',
              'Argentina',
              'Armenia',
              'Aruba',
              'Australia',
              'Austria',
              'Azerbaijan',
              'Bahamas',
              'Bahrain',
              'Bangladesh',
              'Barbados',
              'Belarus',
              'Belgium',
              'Belize',
              'Benin',
              'Bermuda',
              'Bhutan',
              'Bolivia',
              'Bosnia and Herzegovina',
              'Botswana',
              'Bouvet Island',
              'Brazil',
              'British Indian Ocean Territory',
              'Brunei Darussalam',
              'Bulgaria',
              'Burkina Faso',
              'Burundi',
              'Cambodia',
              'Cameroon',
              'Canada',
              'Cape Verde',
              'Cayman Islands',
              'Central African Republic',
              'Chad',
              'Chile',
              'China',
              'Christmas Island',
              'Cocos (Keeling) Islands',
              'Colombia',
              'Comoros',
              'Congo',
              'Cook Islands',
              'Costa Rica',
              'Croatia (Hrvatska)',
              'Cuba',
              'Cyprus',
              'Czech Republic',
              'Denmark',
              'Djibouti',
              'Dominica',
              'Dominican Republic',
              'East Timor',
              'Ecudaor',
              'Egypt',
              'El Salvador',
              'Equatorial Guinea',
              'Eritrea',
              'Estonia',
              'Ethiopia',
              'Falkland Islands (Malvinas)',
              'Faroe Islands',
              'Fiji',
              'Finland',
              'France',
              'France, Metropolitan',
              'French Guiana',
              'French Polynesia',
              'French Southern Territories',
              'Gabon',
              'Gambia',
              'Georgia',
              'Germany',
              'Ghana',
              'Gibraltar',
              'Greece',
              'Greenland',
              'Grenada',
              'Guadeloupe',
              'Guam',
              'Guatemala',
              'Guinea',
              'Guinea-Bissau',
              'Guyana',
              'Haiti',
              'Heard and Mc Donald Islands',
              'Honduras',
              'Hong Kong',
              'Hungary',
              'Iceland',
              'India',
              'Indonesia',
              'Iran (Islamic Republic of)',
              'Iraq',
              'Ireland',
              'Israel',
              'Italy',
              'Ivory Coast',
              'Jamaica',
              'Japan',
              'Jordan',
              'Kazakhstan',
              'Kenya',
              'Kiribati',
              "Korea, Democratic People's Republic of",
              'Korea, Republic of',
              'Kosovo',
              'Kuwait',
              'Kyrgyzstan',
              "Lao People's Democratic Republic",
              'Latvia',
              'Lebanon',
              'Lesotho',
              'Liberia',
              'Libyan Arab Jamahiriya',
              'Liechtenstein',
              'Lithuania',
              'Luxembourg',
              'Macau',
              'Macedonia',
              'Madagascar',
              'Malawi',
              'Malaysia',
              'Maldives',
              'Mali',
              'Malta',
              'Marshall Islands',
              'Martinique',
              'Mauritania',
              'Mauritius',
              'Mayotte',
              'Mexico',
              'Micronesia, Federated States of',
              'Moldova, Republic of',
              'Monaco',
              'Mongolia',
              'Montserrat',
              'Morocco',
              'Mozambique',
              'Myanmar',
              'Namibia',
              'Nauru',
              'Nepal',
              'Netherlands',
              'Netherlands Antilles',
              'New Caledonia',
              'New Zealand',
              'Nicaragua',
              'Niger',
              'Nigeria',
              'Niue',
              'Norfork Island',
              'Northern Mariana Islands',
              'Norway',
              'Oman',
              'Pakistan',
              'Palau',
              'Panama',
              'Papua New Guinea',
              'Paraguay',
              'Peru',
              'Philippines',
              'Pitcairn',
              'Poland',
              'Portugal',
              'Puerto Rico',
              'Qatar',
              'Reunion',
              'Romania',
              'Russian Federation',
              'Rwanda',
              'Saint Kitts and Nevis',
              'Saint Lucia',
              'Saint Vincent and the Grenadines',
              'Samoa',
              'San Marino',
              'Sao Tome and Principe',
              'Saudi Arabia',
              'Senegal',
              'Seychelles',
              'Sierra Leone',
              'Singapore',
              'Slovakia',
              'Slovenia',
              'Solomon Islands',
              'Somalia',
              'South Africa',
              'South Georgia South Sandwich Islands',
              'South Sudan',
              'Spain',
              'Sri Lanka',
              'St. Helena',
              'St. Pierre and Miquelon',
              'Sudan',
              'Suriname',
              'Svalbarn and Jan Mayen Islands',
              'Swaziland',
              'Sweden',
              'Switzerland',
              'Syrian Arab Republic',
              'Taiwan',
              'Tajikistan',
              'Tanzania, United Republic of',
              'Thailand',
              'Togo',
              'Tokelau',
              'Tonga',
              'Trinidad and Tobago',
              'Tunisia',
              'Turkey',
              'Turkmenistan',
              'Turks and Caicos Islands',
              'Tuvalu',
              'Uganda',
              'Ukraine',
              'United Arab Emirates',
              'United Kingdom',
              'United States',
              'United States minor outlying islands',
              'Uruguay',
              'Uzbekistan',
              'Vanuatu',
              'Vatican City State',
              'Venezuela',
              'Vietnam',
              'Virigan Islands (British)',
              'Virgin Islands (U.S.)',
              'Wallis and Futuna Islands',
              'Western Sahara',
              'Yemen',
              'Yugoslavia',
              'Zaire',
              'Zambia',
              'Zimbabwe'
            ]
          },
          {
            question: 'Nombre de la Empresa',
            type: 'text'
          },
          {
            question: 'Nombre completo',
            type: 'text'
          },
          {
            question: 'Cargo dentro de la empresa',
            type: 'text'
          },
          {
            question: 'Email',
            type: 'text'
          },
          {
            question: 'Teléfono',
            type: 'text'
          }
        ]
      },
      {
        group: 'Perfil de la compañia',
        link: 'Perfil de la compañia',
        questions: [
          {
            question: 'Año de fundación de la empresa',
            type: 'number'
          },
          {
            question: 'Cantidad de empleados',
            type: 'number'
          },
          {
            question: 'Tipo de agencia de viajes',
            type: 'select',
            answers: [
              'Agencia de Viajes Online (OTA)',
              'Agencia de viajes Tradicional',
              'Agencia de viajes Corporativa (MICE)',
              'Tour Operador',
              'Otro'
            ]
          },
          {
            question: '¿Pertenece su empresa a algún consorcio de viajes?',
            type: 'select',
            answers: [
              'Airmet',
              'Avasa',
              'Cybas',
              'DitGestión',
              'Edenia Travel',
              'Europa Viajes',
              'Gea',
              'Gebta',
              'Geomoon',
              'Grupo Avnatours',
              'Grupo Bytour',
              'Grupo Star',
              'Grupoontravel',
              'GrupoQualitas',
              'GrupoUnida',
              'icarusgroup',
              'La Red Turística',
              'maxtravelgroup',
              'Nego Servicos',
              'Nivel10',
              'Team Group',
              'Traveltool',
              'Otro',
              'No'
            ]
          },
          {
            question:
              'En su opinión, ¿Cuáles son los puntos fuertes de su empresa en la generación de ventas?',
            type: 'multiple',
            order: true,
            maximum: 3,
            answers: [
              'Calidad',
              'Variedad',
              'Personalización',
              'Experiencia del cliente',
              'Precio',
              'Producto',
              'Especialización en destinos específicos',
              'Especialización en nichos de demanda específicos',
              'Otro'
            ]
          },
          {
            question: '¿Con qué nichos de demanda trabaja?',
            type: 'multiple',
            order: true,
            maximum: 3,
            answers: [
              'Alta gama - Lujo',
              'Sustentabilidad',
              'Aventurera',
              'Corporativo',
              'Golf',
              'Estudiantil / Idiomático',
              'Rural',
              'Sky / Snowboard',
              'Buceo',
              'Náutico',
              'Otro'
            ]
          },
          {
            question: '¿Con qué mercados trabaja en función de la demanda?',
            type: 'multiple',
            answers: [
              'Viajes internacionales fuera de Europa',
              'Viajes regionales en Europa',
              'Viajes domésticos'
            ]
          },
          {
            question: '¿Qué servicios ofrece a sus clientes?',
            type: 'multiple',
            answers: [
              'Cruceros',
              'Alquiler de autos',
              'Alojamiento',
              'Paquetes',
              'Tickets aéreos',
              'Transfers',
              'Actividades / Excursiones',
              'Asistencia al viajero',
              'Eventos y Viajes de Incentivos',
              'Otro'
            ]
          },
          {
            question: '¿Dónde comercializas sus productos?',
            type: 'select',
            answers: [
              'E-commerce (venta directa online)',
              'Presencial (tienda física / email)',
              'Ambos'
            ]
          },
          {
            question:
              '¿Cuándo planifica y genera productos turísticos para una temporada específica?',
            type: 'toggle',
            grouped: true,
            numbered: true,
            answers: [
              {
                group: 'Invierno',
                answers: [
                  '1. Enero',
                  '1. Febrero',
                  '1. Marzo',
                  '1. Abril',
                  '1. Mayo',
                  '1. Junio',
                  '1. Julio',
                  '1. Agosto',
                  '1. Septiembre',
                  '1. Octubre',
                  '1. Noviembre',
                  '1. Diciembre'
                ]
              },
              {
                group: 'Verano',
                answers: [
                  '2. Enero',
                  '2. Febrero',
                  '2. Marzo',
                  '2. Abril',
                  '2. Mayo',
                  '2. Junio',
                  '2. Julio',
                  '2. Agosto',
                  '2. Septiembre',
                  '2. Octubre',
                  '2. Noviembre',
                  '2. Diciembre'
                ]
              },
              {
                group: 'Primavera',
                answers: [
                  '3. Enero',
                  '3. Febrero',
                  '3. Marzo',
                  '3. Abril',
                  '3. Mayo',
                  '3. Junio',
                  '3. Julio',
                  '3. Agosto',
                  '3. Septiembre',
                  '3. Octubre',
                  '3. Noviembre',
                  '3. Diciembre'
                ]
              },
              {
                group: 'Otoño',
                answers: [
                  '4. Enero',
                  '4. Febrero',
                  '4. Marzo',
                  '4. Abril',
                  '4. Mayo',
                  '4. Junio',
                  '4. Julio',
                  '4. Agosto',
                  '4. Septiembre',
                  '4. Octubre',
                  '4. Noviembre',
                  '4. Diciembre'
                ]
              },
              {
                group: 'Planifico para todo el año',
                answers: [
                  '5. Enero',
                  '5. Febrero',
                  '5. Marzo',
                  '5. Abril',
                  '5. Mayo',
                  '5. Junio',
                  '5. Julio',
                  '5. Agosto',
                  '5. Septiembre',
                  '5. Octubre',
                  '5. Noviembre',
                  '5. Diciembre'
                ]
              },
              {
                group: 'No planifico para todo el año',
                answers: ['6. No planifico para todo el año']
              }
            ]
          },
          {
            question:
              '¿Cuándo comienza a vender el producto turístico generado para una temporada específica?',
            type: 'toggle',
            grouped: true,
            numbered: true,
            answers: [
              {
                group: 'Invierno',
                answers: [
                  '1. Enero',
                  '1. Febrero',
                  '1. Marzo',
                  '1. Abril',
                  '1. Mayo',
                  '1. Junio',
                  '1. Julio',
                  '1. Agosto',
                  '1. Septiembre',
                  '1. Octubre',
                  '1. Noviembre',
                  '1. Diciembre'
                ]
              },
              {
                group: 'Verano',
                answers: [
                  '2. Enero',
                  '2. Febrero',
                  '2. Marzo',
                  '2. Abril',
                  '2. Mayo',
                  '2. Junio',
                  '2. Julio',
                  '2. Agosto',
                  '2. Septiembre',
                  '2. Octubre',
                  '2. Noviembre',
                  '2. Diciembre'
                ]
              },
              {
                group: 'Primavera',
                answers: [
                  '3. Enero',
                  '3. Febrero',
                  '3. Marzo',
                  '3. Abril',
                  '3. Mayo',
                  '3. Junio',
                  '3. Julio',
                  '3. Agosto',
                  '3. Septiembre',
                  '3. Octubre',
                  '3. Noviembre',
                  '3. Diciembre'
                ]
              },
              {
                group: 'Otoño',
                answers: [
                  '4. Enero',
                  '4. Febrero',
                  '4. Marzo',
                  '4. Abril',
                  '4. Mayo',
                  '4. Junio',
                  '4. Julio',
                  '4. Agosto',
                  '4. Septiembre',
                  '4. Octubre',
                  '4. Noviembre',
                  '4. Diciembre'
                ]
              },
              {
                group: 'Vendo para todo el año',
                answers: [
                  '5. Enero',
                  '5. Febrero',
                  '5. Marzo',
                  '5. Abril',
                  '5. Mayo',
                  '5. Junio',
                  '5. Julio',
                  '5. Agosto',
                  '5. Septiembre',
                  '5. Octubre',
                  '5. Noviembre',
                  '5. Diciembre'
                ]
              },
              {
                group: 'No vendo para todo el año',
                answers: ['6. No vendo para todo el año']
              }
            ]
          },
          {
            question:
              '¿De dónde obtiene la información para crear los productos?',
            type: 'multiple',
            answers: [
              'Proveedor directo de servicios',
              'Tour Operadores directos de servicios',
              'Eventos (ferias, workshops, etc.)',
              'Motores de reservas',
              'GDS',
              'Otro'
            ]
          },
          {
            question:
              '¿Qué canales utilizas para vender y comunicar tus productos a los clientes?',
            type: 'multiple',
            order: true,
            answers: [
              'Sitio web propio',
              'Motores de búsqueda (Google, Bing, etc)',
              'Sitios web de compañías turísticas (aerolíneas, hoteles, etc)',
              'Metabuscadores (Skyscanner, etc)',
              'Sitios web de comunidades (Tripadvisor, etc)',
              'Diarios y revistas',
              'Facebook',
              'Instagram',
              'Youtube',
              'Tiktok',
              'Twitter',
              'Twitch',
              'Snapchat',
              'Whatsapp',
              'Medios online',
              'Revistas impresas de viajes y lifestyle',
              'Publicidad en TV',
              'Programas de TV',
              'Sitios web oficiales de organismos de turismo',
              'Cine',
              'Revistas digitales de viajes y lifestyle',
              'Blogs',
              'Eventos promocionales',
              'Publicidad en vía pública',
              'Radio',
              'Tienda fisica',
              'Podcast',
              'Influencers y celebridades',
              'Folletos'
            ]
          },
          {
            question: '¿En cuáles invierte en publicidad?',
            type: 'multiple',
            order: true,
            connected: [1, 12],
            answers: [
              'Sitio web propio',
              'Motores de búsqueda (Google, Bing, etc)',
              'Sitios web de compañías turísticas (aerolíneas, hoteles, etc)',
              'Metabuscadores (Skyscanner, etc)',
              'Sitios web de comunidades (Tripadvisor, etc)',
              'Diarios y revistas',
              'Facebook',
              'Instagram',
              'Youtube',
              'Tiktok',
              'Twitter',
              'Twitch',
              'Snapchat',
              'Whatsapp',
              'Medios online',
              'Revistas impresas de viajes y lifestyle',
              'Publicidad en TV',
              'Programas de TV',
              'Sitios web oficiales de organismos de turismo',
              'Cine',
              'Revistas digitales de viajes y lifestyle',
              'Blogs',
              'Eventos promocionales',
              'Publicidad en vía pública',
              'Radio',
              'Tienda fisica',
              'Podcast',
              'Influencers y celebridades',
              'Folletos'
            ]
          },
          {
            question:
              'Cuéntenos sobre la presencia digital de su empresa. Selecciona los medios que utiliza su empresa',
            type: 'text',
            grouped: true,
            answers: [
              {
                group: 'Social media accounts',
                answers: [
                  'Facebook. Por favor, compartirnos url de su cuenta (opcional)',
                  'Instagram. Por favor, compartirnos url de su cuenta (opcional)',
                  'Twitter. Por favor, compartirnos url de su cuenta (opcional)'
                ]
              },
              {
                group: 'Your website',
                answers: [
                  'Por favor, compartirnos url de su sitio web (opcional)',
                  'Por favor, compartirnos url de tu e-commerce (opcional)'
                ]
              }
            ]
          }
        ]
      },
      {
        group: 'Perfil del cliente',
        link: 'Perfil del cliente',
        questions: [
          {
            question: '¿Cuál es el rango etario que predomina en sus clientes?',
            type: 'multiple',
            order: true,
            maximum: 3,
            answers: [
              '18 - 24 años',
              '25 - 34 años',
              '35 - 44 años',
              '45 - 54 años',
              '55 - 64 años',
              '65 - 74 años',
              'Más de 75 años'
            ]
          },
          {
            question:
              '¿Cuánto cree que viajarán sus clientes en los próximos 12 meses?',
            type: 'select',
            grouped: true,
            answers: [
              {
                group: 'Viajes internacionales fuera de Europa',
                answers: [
                  'Mayor que en el últimos 12 meses',
                  'Igual que en el últimos 12 meses',
                  'Menor que en el últimos 12 meses'
                ]
              },
              {
                group: 'Viajes regionales en Europa',
                answers: [
                  'Mayor que en el últimos 12 meses',
                  'Igual que en el últimos 12 meses',
                  'Menor que en el últimos 12 meses'
                ]
              },
              {
                group: 'Viajes domésticos',
                answers: [
                  'Mayor que en el últimos 12 meses',
                  'Igual que en el últimos 12 meses',
                  'Menor que en el últimos 12 meses'
                ]
              }
            ]
          },
          {
            question:
              '¿Cómo cree que será el gasto en viajes de sus clientes en los próximos 12 meses?',
            type: 'select',
            grouped: true,
            answers: [
              {
                group: 'Viajes internacionales fuera de Europa',
                answers: [
                  'Mayor que en el últimos 12 meses',
                  'Igual que en el últimos 12 meses',
                  'Menor que en el últimos 12 meses'
                ]
              },
              {
                group: 'Viajes regionales en Europa',
                answers: [
                  'Mayor que en el últimos 12 meses',
                  'Igual que en el últimos 12 meses',
                  'Menor que en el últimos 12 meses'
                ]
              },
              {
                group: 'Viajes domésticos',
                answers: [
                  'Mayor que en el últimos 12 meses',
                  'Igual que en el últimos 12 meses',
                  'Menor que en el últimos 12 meses'
                ]
              }
            ]
          },
          {
            question: '¿Cómo viajan la mayoría de sus clientes?',
            type: 'order',
            answers: [
              'Solos/as',
              'En pareja',
              'En familia',
              'Con amigos',
              'Corporativo',
              'Viajes grupales (intereses similares: religiosidad, competiciones, pesca, surf, fotografía, etc.)',
              'Otro'
            ]
          },
          {
            question:
              '¿Cómo le compran sus clientes los productos o servicios?',
            type: 'order',
            answers: [
              'Productos o servicios individuales',
              'Paquetes',
              'Servicios combinados'
            ]
          },
          {
            question:
              'En promedio, ¿cuántos viajes al año realizan sus clientes?',
            type: 'number',
            grouped: true,
            answers: [
              {
                group: 'Amount of trips',
                answers: [
                  'Viajes internacionales fuera de Europa',
                  'Viajes regionales en Europa',
                  'Viajes domésticos'
                ]
              }
            ]
          },
          {
            question:
              '¿Cuál es la duración promedio de viaje de estos clientes? En cantidad de días',
            type: 'number',
            grouped: true,
            answers: [
              {
                group: 'Trip Duration',
                answers: [
                  'Viajes internacionales fuera de Europa',
                  'Viajes regionales en Europa',
                  'Viajes domésticos'
                ]
              }
            ]
          },
          {
            question: '¿Dónde se hospedan usualmente estos clientes?',
            type: 'multiple',
            order: true,
            maximum: 5,
            answers: [
              'Camping (motor home, carpa)',
              'Glamping (domo)',
              'Botes / Navegaciones (yate)',
              'Suite/villa de lujo',
              'Casas de vacaciones alquiladas',
              'Alquiler independiente (Airbnb, Homeaway, etc)',
              'Casa de vacaciones propia',
              'Bed & Breakfast',
              'Hostels',
              'Casa de campo',
              'Propiedad tradicional/histórica',
              'Hoteles 3* / 4*',
              'Hoteles de lujo (5* o más)',
              'Hoteles boutique',
              'Hotel urbano',
              'Marcas hoteleras mundialmente reconocidas (Hilton, Marriott, Sheraton, etc.)',
              'Resorts',
              'Cruceros',
              'Hoteles Spa',
              'Alojamiento de estilo contemporáneo/hotel de diseño',
              'Casa de amigos / de familia'
            ]
          },
          {
            question:
              '¿Cuáles son los 5 principales factores que sus clientes tienen en cuenta a la hora de viajar a un destino?',
            type: 'multiple',
            order: true,
            maximum: 5,
            answers: [
              'Nivel de precios en el país (asequibilidad)',
              'Estándares de seguridad/bajos niveles de delincuencia',
              'Estándares sanitarios y de higiene',
              'Amigable con las mascotas',
              'Limpieza',
              'Que el destino tenga pocos turistas',
              'Respeto por la comunidad LGBTQ+',
              'Accesibilidad para personas con capacidades diferentes / discapacidad',
              'Facilidades para los niños',
              'Facilidades para el acceso a las instalaciones sanitarias y médicas',
              'Vuelo directo',
              'Vuelos desde mi aeropuerto local',
              'Poder conducir en auto hasta el destino',
              'Preocupación por el medio ambiente y la sostenibilidad',
              'Minimizar mi huella de carbono',
              'Oportunidades para ir a los parques temáticos',
              'Opciones de alojamiento con todo incluido',
              'Ir a la playa',
              'Ir de compras',
              'Estar activo (deporte, aventura)',
              'Bienestar/Spa',
              'Naturaleza/experiencias al aire libre',
              'Experiencias culturales (museos, conciertos, teatros)',
              'Experiencias históricas',
              'Experiencias en la gran ciudad',
              'Oportunidades de experiencias gastronómicas emocionantes',
              'Cenas de lujo',
              'Visitas/experiencias guiadas/concertadas',
              'Vida nocturna',
              'Vivir nuevas experiencias',
              'Conocer gente nueva',
              'Adquirir una nueva habilidad/desarrollar una habilidad, por ejemplo, el idioma, la cocina o algo similar',
              'Interactuar con la población local',
              'Fotografía',
              'Disponer de servicios personales exclusivos VIP (mayordomo/camarera/chef/comprador personal)'
            ]
          },
          {
            question:
              'En su opinión, ¿cuáles serán los 3 destinos más demandados este año?',
            type: 'text',
            numbered: true,
            grouped: true,
            answers: [
              {
                group: 'Viajes internacionales fuera de Europa',
                answers: ['1. Destino A', '1. Destino B', '1. Destino C']
              },
              {
                group: 'Viajes regionales en Europa',
                answers: ['2. Destino A', '2. Destino B', '2. Destino C']
              },
              {
                group: 'Viajes domésticos',
                answers: ['3. Destino A', '3. Destino B', '3. Destino C']
              }
            ]
          },
          {
            question:
              '¿Qué nivel de importancia asignan sus clientes al medio ambiente y la sostenibilidad?',
            type: 'range',
            minimum: 1,
            maximum: 5
          },
          {
            question:
              '¿Qué nivel de importancia asignan sus clientes a la reducción de su huella de carbono?',
            type: 'range',
            minimum: 1,
            maximum: 5
          },
          {
            question:
              '¿Cuál es el nivel de preocupación por la salud y la seguridad en el destino?',
            type: 'range',
            minimum: 1,
            maximum: 3,
            options: ['High', 'Medium', 'Low'],
            grouped: true,
            numbered: true,
            answers: [
              {
                group: 'Preocupación por la salud',
                answers: [
                  '1. Viajes internacionales fuera de Europa',
                  '1. Viajes regionales en Europa',
                  '1. Viajes domésticos'
                ]
              },
              {
                group: 'Preocupación por la seguridad',
                answers: [
                  '2. Viajes internacionales fuera de Europa',
                  '2. Viajes regionales en Europa',
                  '2. Viajes domésticos'
                ]
              }
            ]
          },
          {
            question:
              '¿Con cuántos meses de antelación reservan sus clientes sus productos?',
            type: 'number',
            grouped: true,
            numbered: true,
            connected: [1, 7],
            answers: [
              {
                group: 'Cruceros',
                answers: [
                  '1. Viajes internacionales fuera de Europa',
                  '1. Viajes regionales en Europa',
                  '1. Viajes domésticos'
                ]
              },
              {
                group: 'Alquiler de auto',
                answers: [
                  '2. Viajes internacionales fuera de Europa',
                  '2. Viajes regionales en Europa',
                  '2. Viajes domésticos'
                ]
              },
              {
                group: 'Alojamiento',
                answers: [
                  '3. Viajes internacionales fuera de Europa',
                  '3. Viajes regionales en Europa',
                  '3. Viajes domésticos'
                ]
              },
              {
                group: 'Paquetes',
                answers: [
                  '4. Viajes internacionales fuera de Europa',
                  '4. Viajes regionales en Europa',
                  '4. Viajes domésticos'
                ]
              },
              {
                group: 'Tickets aéreos',
                answers: [
                  '5. Viajes internacionales fuera de Europa',
                  '5. Viajes regionales en Europa',
                  '5. Viajes domésticos'
                ]
              },
              {
                group: 'Transfers',
                answers: [
                  '6. Viajes internacionales fuera de Europa',
                  '6. Viajes regionales en Europa',
                  '6. Viajes domésticos'
                ]
              },
              {
                group: 'Actividades / Excursiones',
                answers: [
                  '7. Viajes internacionales fuera de Europa',
                  '7. Viajes regionales en Europa',
                  '7. Viajes domésticos'
                ]
              },
              {
                group: 'Asistencia al viajero',
                answers: [
                  '8. Viajes internacionales fuera de Europa',
                  '8. Viajes regionales en Europa',
                  '8. Viajes domésticos'
                ]
              },
              {
                group: 'Eventos y Viajes de incentivos',
                answers: [
                  '9. Viajes internacionales fuera de Europa',
                  '9. Viajes regionales en Europa',
                  '9. Viajes domésticos'
                ]
              },
              {
                group: 'Otro',
                answers: [
                  '10. Viajes internacionales fuera de Europa',
                  '10. Viajes regionales en Europa',
                  '10. Viajes domésticos'
                ]
              }
            ]
          }
        ]
      },
      {
        group: 'Termómetro comercial (Agencias)',
        link: 'Termómetro comercial',
        questions: [
          {
            question:
              '¿Cuáles son sus expectativas empresariales para los próximos 12 meses?',
            type: 'select',
            answers: ['Mejor', 'Igual', 'Peor']
          }
        ]
      },
      {
        group: 'Relación entre el comercio y los DMOs',
        link: 'Comercio y DMOs',
        description:
          'Es muy importante identificar las oportunidades de colaboración entre los principales actores de cada mercado. Por eso queremos preguntarle por su relación con los DMO´s, especialmente en lo que respecta a actividades de co-marketing. ¿Qué es una actividad de co-marketing? Una iniciativa promocional compartida que puede influir en la demanda hacia un destino.',
        questions: [
          {
            question:
              '¿Está dispuesto a diseñar y poner en práctica actividades de co-marketing con destinos turísticos?',
            type: 'range',
            minimum: 1,
            maximum: 5
          },
          {
            question:
              '¿Qué tan importante es para su empresa la relación con los destinos turísticos?',
            type: 'range',
            minimum: 1,
            maximum: 5
          },
          {
            question:
              '¿Cuántas actividades de co-marketing ha realizado en los últimos 12 meses?',
            type: 'number',
            minimum: 1,
            maximum: 12
          },
          {
            question: '¿Qué actividades de co-marketing ha llevado a cabo?',
            type: 'multiple',
            answers: [
              'Branded Content (Contenido de marca)',
              'Influencers',
              'Prensa',
              'Desarrollo de oferta',
              'Eventos B2C',
              'Branded offices (Presencia de marca en oficinas)',
              'Otro',
              'No realizamos actividades de co-marketing'
            ]
          },
          {
            question:
              '¿Qué acciones pueden realizar los DMO para mejorar las sinergias con su agencia?',
            type: 'range',
            minimum: 1,
            maximum: 5,
            grouped: true,
            answers: [
              {
                group: 'Mejorar las sinergias',
                answers: [
                  'Fam Trip',
                  'Formación',
                  'Medios de comunicación y contenidos',
                  'Apoyo en materia de visados y vacunas',
                  'Contacto con el operador receptivo',
                  'Otro'
                ]
              }
            ]
          },
          {
            question:
              'Califique la calidad de la capacitación que ha recibido con respecto a los DMO con las que trabaja.',
            type: 'range',
            customLabels: 'trainingQualityLevels',
            minimum: 1,
            maximum: 5
          }
        ]
      }
    ],
    tradeItalian: [
      {
        group: 'Dati personali',
        link: 'Dati personali',
        questions: [
          {
            question: 'Nazione',
            type: 'select',
            preSelected: 'Italia',
            answers: [
              'Afghanistan',
              'Albania',
              'Algeria',
              'American Samoa',
              'Andorra',
              'Angola',
              'Anguilla',
              'Antarctica',
              'Antigua and/or Barbuda',
              'Argentina',
              'Armenia',
              'Aruba',
              'Australia',
              'Austria',
              'Azerbaijan',
              'Bahamas',
              'Bahrain',
              'Bangladesh',
              'Barbados',
              'Belarus',
              'Belgium',
              'Belize',
              'Benin',
              'Bermuda',
              'Bhutan',
              'Bolivia',
              'Bosnia and Herzegovina',
              'Botswana',
              'Bouvet Island',
              'Brazil',
              'British Indian Ocean Territory',
              'Brunei Darussalam',
              'Bulgaria',
              'Burkina Faso',
              'Burundi',
              'Cambodia',
              'Cameroon',
              'Canada',
              'Cape Verde',
              'Cayman Islands',
              'Central African Republic',
              'Chad',
              'Chile',
              'China',
              'Christmas Island',
              'Cocos (Keeling) Islands',
              'Colombia',
              'Comoros',
              'Congo',
              'Cook Islands',
              'Costa Rica',
              'Croatia (Hrvatska)',
              'Cuba',
              'Cyprus',
              'Czech Republic',
              'Denmark',
              'Djibouti',
              'Dominica',
              'Dominican Republic',
              'East Timor',
              'Ecudaor',
              'Egypt',
              'El Salvador',
              'Equatorial Guinea',
              'Eritrea',
              'Estonia',
              'Ethiopia',
              'Falkland Islands (Malvinas)',
              'Faroe Islands',
              'Fiji',
              'Finland',
              'France',
              'France, Metropolitan',
              'French Guiana',
              'French Polynesia',
              'French Southern Territories',
              'Gabon',
              'Gambia',
              'Georgia',
              'Germany',
              'Ghana',
              'Gibraltar',
              'Greece',
              'Greenland',
              'Grenada',
              'Guadeloupe',
              'Guam',
              'Guatemala',
              'Guinea',
              'Guinea-Bissau',
              'Guyana',
              'Haiti',
              'Heard and Mc Donald Islands',
              'Honduras',
              'Hong Kong',
              'Hungary',
              'Iceland',
              'India',
              'Indonesia',
              'Iran (Islamic Republic of)',
              'Iraq',
              'Ireland',
              'Israel',
              'Italy',
              'Ivory Coast',
              'Jamaica',
              'Japan',
              'Jordan',
              'Kazakhstan',
              'Kenya',
              'Kiribati',
              "Korea, Democratic People's Republic of",
              'Korea, Republic of',
              'Kosovo',
              'Kuwait',
              'Kyrgyzstan',
              "Lao People's Democratic Republic",
              'Latvia',
              'Lebanon',
              'Lesotho',
              'Liberia',
              'Libyan Arab Jamahiriya',
              'Liechtenstein',
              'Lithuania',
              'Luxembourg',
              'Macau',
              'Macedonia',
              'Madagascar',
              'Malawi',
              'Malaysia',
              'Maldives',
              'Mali',
              'Malta',
              'Marshall Islands',
              'Martinique',
              'Mauritania',
              'Mauritius',
              'Mayotte',
              'Mexico',
              'Micronesia, Federated States of',
              'Moldova, Republic of',
              'Monaco',
              'Mongolia',
              'Montserrat',
              'Morocco',
              'Mozambique',
              'Myanmar',
              'Namibia',
              'Nauru',
              'Nepal',
              'Netherlands',
              'Netherlands Antilles',
              'New Caledonia',
              'New Zealand',
              'Nicaragua',
              'Niger',
              'Nigeria',
              'Niue',
              'Norfork Island',
              'Northern Mariana Islands',
              'Norway',
              'Oman',
              'Pakistan',
              'Palau',
              'Panama',
              'Papua New Guinea',
              'Paraguay',
              'Peru',
              'Philippines',
              'Pitcairn',
              'Poland',
              'Portugal',
              'Puerto Rico',
              'Qatar',
              'Reunion',
              'Romania',
              'Russian Federation',
              'Rwanda',
              'Saint Kitts and Nevis',
              'Saint Lucia',
              'Saint Vincent and the Grenadines',
              'Samoa',
              'San Marino',
              'Sao Tome and Principe',
              'Saudi Arabia',
              'Senegal',
              'Seychelles',
              'Sierra Leone',
              'Singapore',
              'Slovakia',
              'Slovenia',
              'Solomon Islands',
              'Somalia',
              'South Africa',
              'South Georgia South Sandwich Islands',
              'South Sudan',
              'Spain',
              'Sri Lanka',
              'St. Helena',
              'St. Pierre and Miquelon',
              'Sudan',
              'Suriname',
              'Svalbarn and Jan Mayen Islands',
              'Swaziland',
              'Sweden',
              'Switzerland',
              'Syrian Arab Republic',
              'Taiwan',
              'Tajikistan',
              'Tanzania, United Republic of',
              'Thailand',
              'Togo',
              'Tokelau',
              'Tonga',
              'Trinidad and Tobago',
              'Tunisia',
              'Turkey',
              'Turkmenistan',
              'Turks and Caicos Islands',
              'Tuvalu',
              'Uganda',
              'Ukraine',
              'United Arab Emirates',
              'United Kingdom',
              'United States',
              'United States minor outlying islands',
              'Uruguay',
              'Uzbekistan',
              'Vanuatu',
              'Vatican City State',
              'Venezuela',
              'Vietnam',
              'Virigan Islands (British)',
              'Virgin Islands (U.S.)',
              'Wallis and Futuna Islands',
              'Western Sahara',
              'Yemen',
              'Yugoslavia',
              'Zaire',
              'Zambia',
              'Zimbabwe'
            ]
          },
          {
            question: 'Azienda',
            type: 'text'
          },
          {
            question: 'Contatto',
            type: 'text'
          },
          {
            question: 'Ruolo',
            type: 'text'
          },
          {
            question: 'Email',
            type: 'text'
          },
          {
            question: 'Telefono',
            type: 'text'
          }
        ]
      },
      {
        group: 'Dati aziendali',
        link: 'Dati aziendali',
        questions: [
          {
            question: 'Anno di costituzione',
            type: 'number'
          },
          {
            question: 'Numero di dipendenti',
            type: 'number'
          },
          {
            question: 'Tipo di azienda',
            type: 'select',
            answers: [
              'Agenzia viaggi online',
              'Agenzia viaggi',
              'MICE / Business Travel',
              'Tour Operator',
              'Altro'
            ]
          },
          {
            question: 'L’azienda appartiene a un consorzio/network?',
            type: 'select',
            answers: [
              'Gattinoni',
              'Bluvacanze',
              'Robintour',
              'Welcome Travel Network',
              'Evolution Travel',
              'Cartorange',
              'Altro',
              'No'
            ]
          },
          {
            question:
              'Che cosa caratterizza la vostra azienda in fase di vendita?',
            type: 'multiple',
            order: true,
            maximum: 3,
            answers: [
              'Qualità',
              'Varietà',
              'Personalizzazione',
              'Customer Experience',
              'Prezzo',
              'Prodotto',
              'Specializzazione su una destinazione specifica',
              'Specializzazione su una nicchia specifica',
              'Altro'
            ]
          },
          {
            question: 'Con che segmenti di clientela lavorate?',
            type: 'multiple',
            order: true,
            maximum: 3,
            answers: [
              'Lusso',
              'Turismo sostenibile',
              'Turismo avventura',
              'Corporate',
              'Golf',
              'Viaggi scolastici',
              'Rurale',
              'Neve/Sci',
              'Diving',
              'Barche/Crociere',
              'Viaggi di nozze',
              'Altro'
            ]
          },
          {
            question: 'Con quali destinazioni lavorate?',
            type: 'multiple',
            answers: [
              'Internazionale extra Europa',
              'Internazionale Europeo',
              'Domestico'
            ]
          },
          {
            question: 'Che Servizi offrite ai clienti?',
            type: 'multiple',
            answers: [
              'Crociera',
              'Noleggio auto',
              'Alloggio alberghiero ed extra',
              'Pacchetti',
              'Biglietteria aerea',
              'Trasferimenti',
              'Attività/escursioni',
              'Assicurazione di viaggio',
              'Eventi e incentive',
              'Altro'
            ]
          },
          {
            question: 'Come vendete i vostri prodotti?',
            type: 'select',
            answers: [
              'E-commerce',
              'Vendita diretta (in agenzia, via email – telefono)',
              'Entrambi'
            ]
          },
          {
            question:
              'Quando pianificate e create i prodotti per le diverse stagioni?',
            type: 'toggle',
            grouped: true,
            numbered: true,
            answers: [
              {
                group: 'Inverno',
                answers: [
                  '1. Gennaio',
                  '1. Febbraio',
                  '1. Marzo',
                  '1. Aprile',
                  '1. Maggio',
                  '1. Giugno',
                  '1. Luglio',
                  '1. Agosto',
                  '1. Settembre',
                  '1. Ottobre',
                  '1. Novembre',
                  '1. Dicembre'
                ]
              },
              {
                group: 'Estate',
                answers: [
                  '2. Gennaio',
                  '2. Febbraio',
                  '2. Marzo',
                  '2. Aprile',
                  '2. Maggio',
                  '2. Giugno',
                  '2. Luglio',
                  '2. Agosto',
                  '2. Settembre',
                  '2. Ottobre',
                  '2. Novembre',
                  '2. Dicembre'
                ]
              },
              {
                group: 'Molla',
                answers: [
                  '3. Gennaio',
                  '3. Febbraio',
                  '3. Marzo',
                  '3. Aprile',
                  '3. Maggio',
                  '3. Giugno',
                  '3. Luglio',
                  '3. Agosto',
                  '3. Settembre',
                  '3. Ottobre',
                  '3. Novembre',
                  '3. Dicembre'
                ]
              },
              {
                group: 'Autunno',
                answers: [
                  '4. Gennaio',
                  '4. Febbraio',
                  '4. Marzo',
                  '4. Aprile',
                  '4. Maggio',
                  '4. Giugno',
                  '4. Luglio',
                  '4. Agosto',
                  '4. Settembre',
                  '4. Ottobre',
                  '4. Novembre',
                  '4. Dicembre'
                ]
              },
              {
                group: "Pianifico e creo prodotti per tutto l'anno",
                answers: [
                  '5. Gennaio',
                  '5. Febbraio',
                  '5. Marzo',
                  '5. Aprile',
                  '5. Maggio',
                  '5. Giugno',
                  '5. Luglio',
                  '5. Agosto',
                  '5. Settembre',
                  '5. Ottobre',
                  '5. Novembre',
                  '5. Dicembre'
                ]
              },
              {
                group: "Non pianifico per tutto l'anno",
                answers: ["6. Non pianifico per tutto l'anno"]
              }
            ]
          },
          {
            question:
              'Iniziate a vendere i prodotti relativi a una specifica stagione?',
            type: 'toggle',
            grouped: true,
            numbered: true,
            answers: [
              {
                group: 'Inverno',
                answers: [
                  '1. Gennaio',
                  '1. Febbraio',
                  '1. Marzo',
                  '1. Aprile',
                  '1. Maggio',
                  '1. Giugno',
                  '1. Luglio',
                  '1. Agosto',
                  '1. Settembre',
                  '1. Ottobre',
                  '1. Novembre',
                  '1. Dicembre'
                ]
              },
              {
                group: 'Estate',
                answers: [
                  '2. Gennaio',
                  '2. Febbraio',
                  '2. Marzo',
                  '2. Aprile',
                  '2. Maggio',
                  '2. Giugno',
                  '2. Luglio',
                  '2. Agosto',
                  '2. Settembre',
                  '2. Ottobre',
                  '2. Novembre',
                  '2. Dicembre'
                ]
              },
              {
                group: 'Molla',
                answers: [
                  '3. Gennaio',
                  '3. Febbraio',
                  '3. Marzo',
                  '3. Aprile',
                  '3. Maggio',
                  '3. Giugno',
                  '3. Luglio',
                  '3. Agosto',
                  '3. Settembre',
                  '3. Ottobre',
                  '3. Novembre',
                  '3. Dicembre'
                ]
              },
              {
                group: 'Autunno',
                answers: [
                  '4. Gennaio',
                  '4. Febbraio',
                  '4. Marzo',
                  '4. Aprile',
                  '4. Maggio',
                  '4. Giugno',
                  '4. Luglio',
                  '4. Agosto',
                  '4. Settembre',
                  '4. Ottobre',
                  '4. Novembre',
                  '4. Dicembre'
                ]
              },
              {
                group: "Pianifico e creo prodotti per tutto l'anno",
                answers: [
                  '5. Gennaio',
                  '5. Febbraio',
                  '5. Marzo',
                  '5. Aprile',
                  '5. Maggio',
                  '5. Giugno',
                  '5. Luglio',
                  '5. Agosto',
                  '5. Settembre',
                  '5. Ottobre',
                  '5. Novembre',
                  '5. Dicembre'
                ]
              },
              {
                group: "Non vendo per tutto l'anno",
                answers: ["6. Non vendo per tutto l'anno"]
              }
            ]
          },
          {
            question:
              'Dove reperite le Informazioni necessarie per creare la vostra offerta',
            type: 'multiple',
            answers: [
              'Contatto diretto con fornitori a destinazione',
              'Contatto diretto con i Tour Operator',
              'Eventi (Fiere, workshop, eccetera)',
              'Booking Engine',
              'GDS',
              'Altro'
            ]
          },
          {
            question:
              'Che canali utilizzate per comunicare la vostra offerta ai clienti?',
            type: 'multiple',
            order: true,
            answers: [
              'Vostro sito internet',
              'Motori di ricerca (Google, .)',
              'Siti web di compagnie di viaggio (compagnie aeree, hotel, )',
              'Meta Search Engines (Skyscanner, etc)',
              'Siti di recensioni online (Tripadvisor, )',
              'Giornali e supplementi',
              'Facebook',
              'Instagram',
              'Youtube',
              'TikTok',
              'Twitter',
              'Twitch',
              'Snapchat',
              'Whatsapp',
              'Media online',
              'Riviste cartacee sullo stile di vita e sui viaggi',
              'Pubblicità in TV',
              'Programmi TV di viaggio',
              'Ente uRciale del turismo / uRcio',
              'Cinema/ﬁlm',
              'Riviste di viaggi e stile di vita online',
              'Blogs',
              'Eventi promozionali',
              'Pubblicità outdoor',
              'Radio',
              'Stores',
              'Podcasts',
              'Inﬂuencer e celebrità',
              'Paper leaﬂets'
            ]
          },
          {
            question: 'In quali investite, pianificate pubblicità?',
            type: 'multiple',
            order: true,
            connected: [1, 12],
            answers: [
              'Vostro sito internet',
              'Motori di ricerca (Google, .)',
              'Siti web di compagnie di viaggio (compagnie aeree, hotel, )',
              'Meta Search Engines (Skyscanner, etc)',
              'Siti di recensioni online (Tripadvisor, )',
              'Giornali e supplementi',
              'Facebook',
              'Instagram',
              'Youtube',
              'TikTok',
              'Twitter',
              'Twitch',
              'Snapchat',
              'Whatsapp',
              'Media online',
              'Riviste cartacee sullo stile di vita e sui viaggi',
              'Pubblicità in TV',
              'Programmi TV di viaggio',
              'Ente uRciale del turismo / uRcio',
              'Cinema/ﬁlm',
              'Riviste di viaggi e stile di vita online',
              'Blogs',
              'Eventi promozionali',
              'Pubblicità outdoor',
              'Radio',
              'Stores',
              'Podcasts',
              'Inﬂuencer e celebrità',
              'Paper leaﬂets'
            ]
          },
          {
            question:
              'Parlateci della vostra presenza online. Selezionate i canali che la vostra azienda usa.',
            type: 'text',
            grouped: true,
            answers: [
              {
                group: 'Account social media',
                answers: [
                  'Facebook. Indicare l’url dell’account (facoltativo)',
                  'Instagram. Indicare l’url dell’account (facoltativo)',
                  'Twitter. Indicare l’url dell’account (facoltativo)'
                ]
              },
              {
                group: 'Sito internet',
                answers: [
                  'Indicare l’url del sito internet (facoltativo)',
                  'Indicare l’url dell’e-commerce (facoltativo)'
                ]
              }
            ]
          }
        ]
      },
      {
        group: 'Profilo della clientela',
        link: 'Profilo della clientela',
        questions: [
          {
            question: 'Quale fascia d’età caratterizza la vostra clientela?',
            type: 'multiple',
            order: true,
            maximum: 3,
            answers: [
              '18 - 24',
              '25 - 34',
              '35 - 44',
              '45 - 54',
              '55 - 64',
              '65 - 74',
              '75+'
            ]
          },
          {
            question:
              'Quanto pensate che viaggerà, nei prossimi 12 mesi, la vostra clientela?',
            type: 'select',
            grouped: true,
            answers: [
              {
                group: 'Viaggi Extra Europa',
                answers: [
                  'Più degli ultimi 12 mesi',
                  'Come negli ultimi 12 mesi',
                  'Meno degli ultimi 12 mesi'
                ]
              },
              {
                group: 'Viaggi in Europa',
                answers: [
                  'Più degli ultimi 12 mesi',
                  'Come negli ultimi 12 mesi',
                  'Meno degli ultimi 12 mesi'
                ]
              },
              {
                group: 'Viaggi in Italia',
                answers: [
                  'Più degli ultimi 12 mesi',
                  'Come negli ultimi 12 mesi',
                  'Meno degli ultimi 12 mesi'
                ]
              }
            ]
          },
          {
            question:
              'Quanto pensate che spenderà, nei prossimi 12 mesi, la vostra clientela?',
            type: 'select',
            grouped: true,
            answers: [
              {
                group: 'Viaggi Extra Europa',
                answers: [
                  'Più degli ultimi 12 mesi',
                  'Come negli ultimi 12 mesi',
                  'Meno degli ultimi 12 mesi'
                ]
              },
              {
                group: 'Viaggi in Europa',
                answers: [
                  'Più degli ultimi 12 mesi',
                  'Come negli ultimi 12 mesi',
                  'Meno degli ultimi 12 mesi'
                ]
              },
              {
                group: 'Viaggi in Italia',
                answers: [
                  'Più degli ultimi 12 mesi',
                  'Come negli ultimi 12 mesi',
                  'Meno degli ultimi 12 mesi'
                ]
              }
            ]
          },
          {
            question: 'Come viaggiano i vostri clienti?',
            type: 'order',
            answers: [
              'Da soli',
              'In coppia',
              'In famiglia',
              'Gruppo di amici',
              'Viaggi d’affari',
              'Gruppo (anche per interesse: surf, diving, fotografia, pesca, pellegrinaggi, ecc),',
              'Altro'
            ]
          },
          {
            question: 'Cosa comprano i vostri clienti?',
            type: 'order',
            answers: [
              'Singoli prodotti e servizi',
              'Pacchetti',
              'Combinazione di servizi'
            ]
          },
          {
            question: 'Quanti viaggi fanno in media per anno i vostri clienti?',
            type: 'number',
            grouped: true,
            answers: [
              {
                group: 'Media per anno',
                answers: [
                  'Viaggi Extra Europa',
                  'Viaggi in Europa',
                  'Viaggi in Italia'
                ]
              }
            ]
          },
          {
            question: 'Quanto durano in media i viaggi dei vostri clienti?',
            type: 'number',
            grouped: true,
            answers: [
              {
                group: 'Durano in media',
                answers: [
                  'Viaggi Extra Europa',
                  'Viaggi in Europa',
                  'Viaggi in Italia'
                ]
              }
            ]
          },
          {
            question: 'Che alloggio scelgono i vostri clienti?',
            type: 'multiple',
            order: true,
            maximum: 5,
            answers: [
              'Campeggio (roulotte, autocaravan, casa mobile, tenda)',
              'Glamping (campeggio di lusso)',
              'Barca (house boat, yacht)',
              'Suite/villa di lusso Casa vacanze (non la propria casa privata)',
              'Alloggio privato (per esempio Airbnb, Homeaway, scambio di case)',
              'Casa privata a destinazione',
              'Bed & Breakfast',
              'Hotel/ostello economico',
              'Agriturismo',
              'Proprietà tradizionale/storica',
              'Albergo 3-4*',
              'Hotel di lusso (5+)',
              'Albergo di charme',
              'Albergo di città',
              'Hotel di catena riconosciuta a livello internazionale (Hilton, Marriott, Sheraton, )',
              'Resort',
              'Crociera',
              'Spahotel',
              'Alloggio in stile contemporaneo/design hotel',
              'Soggiorno con amici o in famiglia'
            ]
          },
          {
            question:
              'Quali sono i 5 elementi più importanti per i vostri clienti nella scelta di una destinazione?',
            type: 'multiple',
            order: true,
            maximum: 5,
            answers: [
              'Livello dei prezzi nel paese (accessibilità economica)',
              'Standard di sicurezza/basso livello di criminalità',
              'Standard di salute e igiene',
              'Accoglienza degli animali domestici',
              'Pulizia',
              'Presenza di pochi turisti',
              'LGBTQ+-friendly',
              'Accessibilità per i diversamente abili',
              'Adatto ai bambini',
              'Facile accesso alle strutture sanitarie e mediche',
              'Volo diretto',
              "Voli dall'aeroporto locale",
              'Poter guidare ﬁno a destinazione',
              'Attenzione ambientale e sostenibilità',
              "Minimizzazione dell'impatto ambientale",
              'Possibilità di visitare parchi a tema',
              'Possibilità di alloggio all inclusive',
              'Andare in spiaggia',
              'Fare shopping Essere attivi (sport, avventura)',
              'Benessere/Spa',
              "Esperienze nella natura/all'aperto",
              'Esperienze culturali (musei, concerti, teatri)',
              'Esperienze storiche',
              'Esperienze nelle grandi città',
              'Opportunità di esperienze alimentari eccitanti',
              'Cene degustazione/ Visite guidate/organizzate/esperienze',
              'Vita notturna Vivere nuove esperienze',
              'Incontrare nuove persone',
              "Acquisire / sviluppare un'abilità, ad esempio la lingua, la cucina o simili Interagire con la gente del posto",
              'Fotograﬁa',
              'Disponibilità di servizi personali esclusivi',
              'VIP (maggiordomo personale/cameriera/cuoco/personal shopper)'
            ]
          },
          {
            question: 'Quali saranno le top tre destinazioni dell’anno?',
            type: 'text',
            numbered: true,
            grouped: true,
            answers: [
              {
                group: 'Viaggi Extra Europa',
                answers: [
                  '1. Destinazioni A',
                  '1. Destinazioni B',
                  '1. Destinazioni C'
                ]
              },
              {
                group: 'Viaggi in Europa',
                answers: [
                  '2. Destinazioni A',
                  '2. Destinazioni B',
                  '2. Destinazioni C'
                ]
              },
              {
                group: 'Viaggi in Italia',
                answers: [
                  '3. Destinazioni A',
                  '3. Destinazioni B',
                  '3. Destinazioni C'
                ]
              }
            ]
          },
          {
            question:
              'Quanto sono importanti, per i vostri clienti, l’ambiente e la sostenibilità?',
            type: 'range',
            minimum: 1,
            maximum: 5
          },
          {
            question:
              'Quanto è importante, per i vostri client, ridurre l’inquinamento?',
            type: 'range',
            minimum: 1,
            maximum: 5
          },
          {
            question:
              'Quanto sono importanti salute e sicurezza personale a destinazione?',
            type: 'range',
            minimum: 1,
            maximum: 3,
            grouped: true,
            numbered: true,
            answers: [
              {
                group: 'Salute',
                answers: [
                  '1. Viaggi extra Europa',
                  '1. Viaggi in Europa',
                  '1. Viaggi in Italia'
                ]
              },
              {
                group: 'Sicurezza personale',
                answers: [
                  '2. Viaggi extra Europa',
                  '2. Viaggi in Europa',
                  '2. Viaggi in Italia'
                ]
              }
            ]
          },
          {
            question:
              'Quante mesi in anticipo vengono prenotati i vostri prodotti?',
            type: 'number',
            grouped: true,
            numbered: true,
            connected: [1, 7],
            answers: [
              {
                group: 'Crociere',
                answers: [
                  '1. Viaggi Extra Europa',
                  '1. Viaggi in Europa',
                  '1. Domestic travel'
                ]
              },
              {
                group: 'Noleggio Auto',
                answers: [
                  '2. Viaggi Extra Europa',
                  '2. Viaggi in Europa',
                  '2. Domestic travel'
                ]
              },
              {
                group: 'Alloggio alberghiero ed extra',
                answers: [
                  '3. Viaggi Extra Europa',
                  '3. Viaggi in Europa',
                  '3. Domestic travel'
                ]
              },
              {
                group: 'Pacchetti',
                answers: [
                  '4. Viaggi Extra Europa',
                  '4. Viaggi in Europa',
                  '4. Domestic travel'
                ]
              },
              {
                group: 'Biglietteria aerea',
                answers: [
                  '5. Viaggi Extra Europa',
                  '5. Viaggi in Europa',
                  '5. Domestic travel'
                ]
              },
              {
                group: 'Trasferimenti',
                answers: [
                  '6. Viaggi Extra Europa',
                  '6. Viaggi in Europa',
                  '6. Domestic travel'
                ]
              },
              {
                group: 'Attività/escursioni',
                answers: [
                  '7. Viaggi Extra Europa',
                  '7. Viaggi in Europa',
                  '7. Domestic travel'
                ]
              },
              {
                group: 'Assicurazione di viaggio',
                answers: [
                  '8. Viaggi Extra Europa',
                  '8. Viaggi in Europa',
                  '8. Domestic travel'
                ]
              },
              {
                group: 'Eventi e incentive',
                answers: [
                  '9. Viaggi Extra Europa',
                  '9. Viaggi in Europa',
                  '9. Domestic travel'
                ]
              },
              {
                group: 'Altro',
                answers: [
                  '10. Viaggi Extra Europa',
                  '10. Viaggi in Europa',
                  '10. Domestic travel'
                ]
              }
            ]
          }
        ]
      },
      {
        group: 'Termometro del trade 1 domanda',
        link: 'Termometro del trade',
        questions: [
          {
            question:
              'Quali sono le vostre aspettative di business per i prossimi 12 mesi?',
            type: 'select',
            answers: ['Meglio', 'Uguale', 'Peggio']
          }
        ]
      },
      {
        group: 'Relazione con gli enti del turismo',
        link: 'Gli enti',
        description:
          'E’ molto importante mettere a fuoco le possibilità di collaborazione tra i key player del mercato. Per questo vorremmo sapere di più da voi sulle vostre relazioni con gli enti del turismo, specialmente quando si parla di attività di co-marketing. Che cos’è un’attività co-marketing? Un’iniziativa promozionale condivisa che possa influenzare la domanda verso una destinazione.',
        questions: [
          {
            question:
              'Siete disponibili a programmare e implementare iniziative di co-marekting con destinazioni turistiche?',
            type: 'range',
            minimum: 1,
            maximum: 5
          },
          {
            question:
              'Quanto è importante per la vostra azienda la relazione con le destinazioni turistiche?',
            type: 'range',
            minimum: 1,
            maximum: 5
          },
          {
            question:
              'Quante iniziative co-marketing avete promosso negli ultimi 12 mesi?',
            type: 'number',
            minimum: 1,
            maximum: 12
          },
          {
            question:
              'Che genere di attività co-marketing avete promosso in passato?',
            type: 'multiple',
            answers: [
              'Branded Content',
              'Inﬂuencers',
              'Stampa',
              'Sviluppo dell’offerta',
              'Eventi B2C',
              'Materiale decorativo',
              'Altro',
              'Non programmiato attività co-marketing'
            ]
          },
          {
            question:
              'A quali attività, di quelle promosse da un ente del turismo, siete interessati per potenziali singergie?',
            type: 'range',
            minimum: 1,
            maximum: 5,
            grouped: true,
            answers: [
              {
                group: 'attività',
                answers: [
                  'Fam trip',
                  'Training',
                  'Materiale fotografico e informativo',
                  'Supporto con i visti e le vaccinazioni',
                  'Contatto con le aziende incoming',
                  'Altro'
                ]
              }
            ]
          },
          {
            question:
              'Valuta la qualità della formazione che hai ricevuto in merito ai DMO con cui lavori.',
            type: 'range',
            customLabels: 'trainingQualityLevels',
            minimum: 1,
            maximum: 5
          }
        ]
      }
    ]
  };
}
